export default {
  lawsAndRegulations: {
    seleteTitle: 'What you choose is:',
    title1:
      "Opinions of the Supreme People's Court on Providing Judicial Services and Guarantees for Hainan's Comprehensive Deepening of Reform and Opening-up",
    title2:
      "Approval of the State Council's Agreement to Set up China (Hainan) Free Trade Pilot Zone",
    title3: 'Regulations of Hainan Province on Tourism',
    desc1:
      "SPC issued (2018) No.16 In order to further study and carry out Xi Jinping's new era socialist ideas with Chinese characteristics and the spirit of the 19th National Congress of the Party, earnestly implement the major decisions and arrangements of the Party Central Committee with Xi Jinping as its core to support Hainan's comprehensive deepening of reform and opening-up, give full play to the functions of the people's courts, and promote the construction of the Hainan Free Trade Pilot Zone and the Free Trade Port with Chinese Characteristics.",
    desc2:
      "Approval of the State Council's Agreement to Set up China (Hainan) Free Trade Pilot Zone（the State Council Letter (2018) No.119）The People's Government, Ministry of Commerce of Hainan Province: Your request for the establishment of China (Hainan) Free Trade Pilot Zone has received. The approval is as follows: First, agreed to set up China (Hainan) Free Trade Pilot Zone.",
    desc3:
      "Article 1 In order to safeguard the legitimate rights and interests of tourists, tour operators and their employees, protect and rationally utilize tourism resources, standardize the order of the tourism market, promote the construction of Hainan International Tourism Island, and promote the sustained and healthy development of tourism, the Regulations are formulated in accordance with the Tourism Law of the People's Republic of China and other relevant laws and regulations, as well as the actual situation of the province. "
  },
  classType: {
    multilevel: 'multilevel contain',
    singlelevel: 'singlelevel statistics'
  },
  accountjd: {
    emailMsg: 'Can fill in the mailbox as a login account',
    phoneOremail: 'Mobile phone number is the login account！',
    phoneOremail2: 'Email is the login account！',
    phoneMsg: 'Mobile phone number or email address, required',
    otherphoneMsg: 'Overseas mobile phone number does not support login'
  },
  centerThree: {
    number: 'Number: ',
    countdown: 'Countdown: ',
    isoverdue: 'Is overdue: ',
    mediationProgress: 'Mediation progress',
    disputeOccurred: 'Place of dispute',
    applicant: 'Applicant',
    respondent: 'Respondent',
    applicantsAgent: "Applicant's agent",
    respondentsAgent: "Respondent's agent",
    disputeDescription: 'Dispute description',
    judicial: 'The judicial confirmation',
    arbitration: 'Online arbitration',
    litigation: 'Lawsuit filed',
    applicantsAppeal: "Applicant's appeal",
    registrationTime: 'Registration time: ',
    detailsDispute: 'Details of the dispute',
    crossExamination: 'Cross-examination',
    applicationExtension: 'Application for extension',
    confirmExtension: 'Confirm the extension',
    applicationFiling: 'Application for filing',
    haveAppliedJudicialConfirmation: 'Have applied for judicial confirmation',
    ApplyJudicialConfirmation: 'Apply for judicial confirmation',
    haveAppliedApplicationMediation:
      'Have applied for the application of mediation',
    applyApplicationMediation: 'Apply for the application of mediation',
    extensionConfirmation: 'Extension confirmation',
    numberDaysExtended: 'Number of days extended: ',
    reasonsExtension: 'Reasons for extension: ',
    numberDaysExtended2: 'Number of days extended',
    reasonsExtension2: 'Reasons for extension',
    reject: 'Reject',
    confirm: 'Confirm',
    extensionCertification: 'Extension certification',
    reasonsApplication: 'Reasons for application',
    pleaseEnter: 'Please enter the content',
    waitingMediation: 'Waiting for mediation',
    inMediation: 'In mediation',
    mediationSucceed: 'Mediation succeed',
    mediationFail: 'Mediation fails',
    decideWhetherWithdraw:
      'Please decide whether to withdraw according to the actual situation, once withdrawn, the mediation agency will not provide mediation service.',
    warmPrompt: 'Warm prompt',
    whetherToAsk:
      'Whether to ask the court to issue a mediation agreement, if clicked  "Confirm ", it will jump to the request page for you.',
    tips: 'Tips',
    tips1: 'Warm prompt',
    extensionNumber: 'The extension must be a number',
    enterExtension: 'Please enter the reasons for extension',
    cantBeBlank: "Reasons for extension can't be blank",
    validationDidntPass: "Form validation didn't pass",
    confirmExtensionSucceed: 'Confirm extension succeed',
    haveRefusedExtension: 'Have refused extension',
    applicationForLitigation: 'Application for litigation',
    haveAppliedForLitigation: 'Have applied for litigation',
    cancel: 'Cancel',
    orJudicial: 'Is the application for judicial confirmation submitted?',
    orLitigation: 'Whether to file a lawsuit?',
    orArbitration: 'Whether to transfer arbitration online?',
    submitApplySucceed: 'Application submitted successfully',
    judicialed: 'JudicialConfirmationHasBeenAppliedFor',
    litigationed: 'ALawsuitHasBeenFiled',
    arbitrationed: 'OnlineArbitrationHasBeenApplied',
    mediatorRecordingReminder:
      'Mediator {mediatorName} has started recording the video. Please be mindful of your words during the mediation.'
  },
  menuDetail: {
    caseDetails: 'Case details',
    accept: 'Accept',
    notAccept: 'Not accept',
    allotMediators: 'Allot the mediators',
    reallotMediators: 'Reallot he mediators',
    bookMediation: 'Book mediation',
    sendInstruments: 'Send instruments',
    NoobjectionMediation: 'No-objection mediation programme',
    NoncontroversialFactsConfirmation:
      'Non-controversial facts confirmation agreement',
    mediationStatus: 'Mediation status',
    mediationFailed: 'Mediation failed',
    applicationJudicialConfirmation: 'Application for judicial confirmation',
    applicationMediation: 'Application for mediation',
    generateElectronicFiles: 'Generate electronic files',
    signInstruments: 'Sign instruments',
    noAgreementYet: 'No agreement yet',
    chooseMediator: 'Choose a mediator',
    enterMediatorsName: "Please enter the mediator's name",
    choose: 'Choose',
    importantTips: 'Important tips',
    acceptTheCase:
      'Please decide whether to accept the case according to actual situation of the dispute, if you choose "not accept", the applicant won\'t enjoy the mediation services provided by the institution.',
    notAcceptTheCase:
      'Please decide whether to accept the case according to actual situation of the dispute, if you choose "accept", the applicant won\'t enjoy the mediation services provided by the institution.',
    endingMediationReports: 'Ending mediation reports',
    serialNumber: 'Serial number',
    plaintiff: 'Plaintiff',
    contactNumber: 'Contact number',
    contactType: 'Contact',
    agentLitem: 'Agent ad litem',
    agentsPhoneNumber: "Agent's phone number",
    Defendant: 'Defendant',
    reasonsToEndMediation: 'Reasons to end mediation',
    selectTheReasonsMediation: 'Please select the reasons for mediation',
    enterOtherReasons: 'Please enter other reasons',
    plaintiffsOpinions: "Plaintiff's opinions: ",
    enterPlaintiffsOpinions: "Please enter the plaintiff's opinions",
    defendantsOpinions: "Defendant's opinions: ",
    enterDefendantsOpinions: "Please enter the defendant's opinions",
    majorDifferences: 'Major differences between the two parties: ',
    nonContentiousFacts: 'Non-contentious facts confirmed by both parties: ',
    majorDifferences2: 'Major differences between the two parties',
    nonContentiousFacts2: 'Non-contentious facts confirmed by both parties',
    haveSubmitted: 'Have submitted',
    notSubmitted: 'Not submitted',
    submit: 'submit',
    haveSaved: 'Have saved',
    preview: 'preview',
    invalid: 'invalid',
    confirmationMediationFailure: 'Confirmation of mediation failure',
    changeCaseStatus:
      'Whether to change the case status to "mediation failed", after confirmation, you will end the mediation of this case and write a mediation final report',
    notAcceptCase: "Didn't accept the case",
    detailedReasons: 'Detailed reasons',
    screeningMediationOrganization: 'Screening of mediation organization',
    enterReasonsTransfer:
      'Please enter the reasons for the transfer first(required)',
    selectType: 'Please select the type',
    enterOrganization: "Please enter the organization's name",
    transfer: 'Transfer',
    disputeInformation: 'Dispute information',
    caseMaterials: 'Case materials',
    clericalMaterials: 'Clerical materials',
    mediationRecords: 'Mediation records',
    notUnderOrganization: "Not under this organization's jurisdiction",
    otherOrganizationsAccepted: 'Other organizations have accepted/resolved',
    mediationIsntGranted:
      "Mediation isn't granted according to the nature of the case",
    mediationTypes: 'All mediation types',
    peopleMediation: "People's mediation",
    administrativeMediation: 'Administrative mediation',
    saveSuccessfully: 'Save successfully',
    mediator1: 'Test mediator 1',
    submitSuccessfully: 'Submit successfully',
    mediationHasFailed: 'Mediation has failed',
    mediationTranscript: 'Mediation transcript',
    investigationTranscript: 'Investigation transcript',
    asssignMediatorSuccessfully: 'Assign mediator successfully',
    transferMediationOrganizationSuccessfully:
      'Transfer mediation organization successfully',
    rejectSuccessfully: 'Reject successfully',
    acceptSuccessfully: 'Accept successfully',
    other: 'Other',
    plaintiffRequestsClosure: 'Plaintiff requests for closure',
    defendantRequestsClosure: 'Defendant requests for closure',
    cantDeliverToDefendant: "Can't deliver to the defendant",
    contactParties:
      'Mediation is successful! Please contact the parties to confirm offline, and inform the parties to make a choice within 30 seconds. If do not select, the withdrawal of the case would be processed by default. Otherwise, an application for mediation will be issued.',
    requestMediationAgreement: 'Request for a mediation agreement.',
    withdrawCase: 'Withdraw the case',
    pleaseWait: 'Please wait.',
    judicail: 'The judicial confirmation',
    litigation: 'Lawsuit filed',
    arbitration: 'Online arbitration',
    ApplySuitConfirmation: 'litigation',
    ApplyConfirmation: 'arbitration',
    exitUser: {
      thisUser: 'This user',
      hasHistory: 'historical data exists',
      isOverwrite: 'Does it overwrite the current information? ',
      yes: 'Yes',
      no: 'No'
    }
  },
  MediationRoom: {
    mediationRoom: 'Mediation room',
    contactsList: 'Contacts list',
    send: 'send',
    noMoreMessages: 'No more messages',
    companyName: 'Enterprise‘s name',
    companyCode: 'The credit code of the enterprise',
    groupChat: 'Group chat',
    enterContentBeforeSending: 'Please enter the content before sending',
    refreshAndTry: 'Message delivery failed, please refresh and try again',
    chatDisconnected: 'Chat is disconnected, please refresh and try again',
    group: 'Group '
  },
  step3: {
    respondentsInformation: "Respondent's {number} information: ",
    respondentType: 'Respondent type: ',
    respondentsName: "Respondent's name",
    respondentGender: "Respondent's gender",
    respondent: 'Respondent: ',
    enterOneContact:
      'Please enter at least one contact way of respondent {number}, mobile phone',
    enterRespondentsTel: "Please enter the respondent's {number} Tel!"
  },
  step2: {
    cancel: 'Cancel',
    legalRepresentative: 'Legal representative: ',
    contactNumber: 'Contact number: ',
    haveAdded: 'Have added',
    added: 'Have added',
    applicant: 'Applicant: ',
    haveDeleted: 'Have deleted',
    haveUpdate: 'Have update',
    applicantsInformation: "Applicant's {number} information: ",
    examinationAndApproval: 'In the examination and approval of judges',
    applicantType: 'Applicant type: ',
    applicantName: 'Applicant name: ',
    enterRealName: 'Please enter real name',
    gender: 'Gender: ',
    enterPhoneNumber: 'Please enter phone number',
    enterOneWay: 'Please enter at least one way, mobile/email',
    enterPhoneRequired:
      'Please enter your phone number （Phone number or email is required）',
    enterEmailRequired:
      'Please enter your email （Phone number or email is required）',
    IDNumber: 'ID number：',
    IDNumber2: 'ID number',
    enterIDNumber: 'Please enter 18-digit 2nd-generation ID number',
    detailAddress: 'Detail address:',
    detailAddressIsRequired: 'Detail address is required',
    useIssuingInstrument: 'Use when issuing an instrument',
    enterOrganiztionsName: "Please enter the organiztion's name",
    creditCode: 'Credit code: ',
    enterUnifiedSocialCreditCode: 'Please enter unified social credit code',
    enterName: 'Please enter name',
    legalPersonGender: 'Legal person gender: ',
    enterDetailedAddress: 'Please enter detailed address',
    organizationsRepresentative: "Organization's representative: ",
    representativeGender: 'Representative gender: ',
    agent: 'Agent: ',
    agent2: 'Agent',
    Optional:
      "(Optional)If you have an agent please enter the information, otherwise you don't need",
    delegateType: 'Delegate type: ',
    agentType: 'Agent type: ',
    agentName: 'Agent name: ',
    agentGender: 'Agent gender: ',
    enterUsefulTel: 'Please the the useful Tel',
    letterAuthorization: 'Letter of authorization: ',
    uploadLetterAuthorization: 'Please upload the letter of authorization',
    telFormatIncorrect: 'The Tel format is incorrect',
    IDCardFormatIncorrect: 'ID card format is incorrect',
    creditCodeFormatIncorrect: 'Credit code format is incorrect',
    naturalPerson: 'Natural person',
    unincorporatedOrganization: 'Unincorporated organization',
    generalAuthorizedAgent: 'General authorized agent',
    specialAuthorizedAgent: 'Special authorized agent',
    cantBeModified:
      "The person has information in approval, can't be modified now",
    expand: 'Expand',
    hide: 'Hide',
    operateAgain:
      'The form information is entered incorrectly, please operate again',
    enterOneContact:
      'Please enter at least one contact way of applicant {number}, mobile phone',
    enterApplicantsTel: "Please enter the applicant's {number} Tel!",
    reuploadFile: 'Please reupload the file',
    hasntLoggedIn: "User hasn't logged in",
    deleteFile:
      'This operation will permanently delete the file, whether to continue',
    DeletionCanceled: 'Deletion has been canceled',
    nationality: 'Nationality：',
    selectNationality: 'Please select your nationality',
    national: 'National: ',
    national2: 'National',
    deleteAgent: 'Delete the agent'
  },
  step1: {
    areasOfExpertise: 'Areas of expertise: ',
    organization: 'Organization: ',
    organizationType2: 'Organization type',
    enter: 'Please enter',
    detailAddress: 'Detail address:',
    disputeType: 'Dispute type: ',
    disputeDescription2: 'Description of the dispute: ',
    disputeDescription:
      'The dispute description is the basic information of the matters in which you apply for mediation',
    myAppeal: 'My appeal: ',
    disputeOccurred: 'Place of dispute: ',
    myappealPurpose:
      'My appeal is the purpose you want to achieve by applying for mediation',
    mediationOrganization: 'Mediation organization: ',
    selectMediationOrganization: 'Select the mediation organization',
    organizationType: 'Organization type: ',
    searchMediationOrganization: 'Search the mediation organization',
    number: 'Number',
    residentArea: 'resident area：',
    fieldExpertise: 'The field of expertise',
    organizationLocation: 'Organization location',
    numberMediators: 'Number of mediators',
    pleaseSelect: 'Please select',
    searchMediator: 'Search the mediator',
    nextStep: 'Next step',
    selectType: 'Please select a type',
    clickStartVoice: 'Click to start voice',
    province: 'Guangzhou, Guangdong Province',
    selectMediationOrganizationFirst:
      'Please select a mediation organization first',
    voiceNotSupported: 'Voice to text is not supported in this browser',
    updateSecceed: 'Update secceed'
  },
  evidence: {
    uploadEvidence: 'Upload evidence',
    identityCertificate: 'Identity certificate',
    materialName: 'Material name: ',
    uploadMaterial: 'Upload material',
    uploader: 'Uploader: ',
    noInformationAvailable: 'No information available',
    listEvidence: 'List of evidence',
    authenticity: 'Authenticity',
    enterReason: 'Please enter the reason',
    accepted: 'Accepted',
    notAccepted: 'Not accepted',
    legality: 'Legality',
    relevance: 'Relevance',
    crossExamination: 'Cross-examination',
    opinionsCrossExamination: 'Opinions about cross-examination',
    haveCrossExamination: 'Have completed cross-examination',
    crossExaminationSucceed: 'Cross-examination succeed',
    crossexaminationCantBeBlank:
      "Opinions about cross-examination can't be blank",
    chooseRecognition: 'Please choose the recognition degree for the evidence',
    continueDeletingfile: 'Whether to continue deleting the file?',
    deletionSucceed: 'Deletion succeed!',
    other: 'Other'
  },
  clerK: {
    uploadDocuments: 'Upload documents'
  },
  mediationRecord: {
    mobilePhoneNumber: 'Mobile phone number: ',
    mobilePhoneNumber2: 'Mobile phone number',
    record: 'Record: ',
    location: 'Location: ',
    time: 'Time: ',
    participant: 'Participant: ',
    happy: 'Happy',
    angry: 'Angry',
    sad: 'Sad',
    calm: 'Calm',
    notStart: 'Not start',
    underWay: 'Under way',
    videoMediation: 'Video mediation',
    videoInvestigation: 'Video investigation',
    videoAuthentication: 'Video certification',
    offlineMediation: 'Offline mediation',
    offlineInvestigation: 'Offline investigation',
    invitationObservation: 'Invitation for observation',
    enterVideo: 'Enter the video',
    videoRecording: 'Video recording',
    sendTranscript: 'Send the transcript',
    viewTranscript: 'View the transcript',
    faceRecognitionExpression: 'Proportion of face recognition expression',
    videoDuration: 'Video duration(minutes)',
    clickPlay: 'Click to play or right-click on the link to save',
    noRecordsYet: 'No records yet',
    enterTime: 'Please enter the time',
    enterDisputeType: 'Please enter the dispute type',
    enterAddress: 'Please enter the address',
    enterDetailAddress: 'Please enter detailed address',
    enterDetailAddressAndNation:
      'Please enter your address (street,city,state/province/region,country)',
    enterIdNumber: 'Please enter the ID number',
    haveSent: 'Have sent',
    refresh: 'Refresh',
    agree: 'Agree',
    reject: 'Reject',
    send: 'Send',
    save: 'Save',
    scanQR: 'Scan QR code',
    signatureCompleted: 'Handwritten signature has been completed',
    afraid: 'Afraid',
    annoyed: 'Annoyed',
    surprised: 'Surprised',
    savedSuccessfully: 'Emotional recognition saved successfully',
    radarMap: 'Emotional recognition saved successfully',
    enterApplicantsName: "Please enter the applicant's name",
    enterTranscript: 'Please enter the transcript',
    enterTel: 'Please enter the 11-digit Tel',
    phoneError: 'Phone number input error',
    signatureNotCompleted: "The signature hasn't been completed",
    minutes: 'Minutes',
    emotionalRecognition: 'Emotional recognition'
  },
  index: {
    listCases: 'List of my cases',
    pendingMediationCases: 'Pending mediation cases',
    completedCases: 'Completed cases',
    all: 'All',
    isMediating: 'Is mediating',
    searchNumberName: 'Search Number/Name',
    searchResults: 'Search results: {number} case in total',
    disputeNo: 'Dispute number',
    disputeNo2: 'Dispute number: ',
    viewDetails: 'View details',
    submitApplication: 'Submit the application for extension',
    applicationCantBeBlank: "The reasons for application can't be blank",
    listOfInquries: 'List of my inquries',
    uncompletedConsultation: 'Uncompleted consultation ',
    searchByConsultation: 'Search by consultation number',
    consultationNo: 'Consultation number',
    serviceStaff: 'Service staff',
    applicationForAppeal: 'Application for appeal',
    disputeDescription: 'Description of the dispute',
    registrationTime: 'Registration time',
    noData: 'No date found'
  },
  uploadfile: {
    uploadFiles: 'Upload files',
    sureUpload: 'Confirm upload',
    classification: 'Classification',
    selectFile: 'Select a file',
    clickUpload: 'Click upload',
    tip: 'Tip: The current dispute is',
    suggestedEvidence: 'The suggested evidence is',
    limitedSize:
      "It is recommended to upload PNG, PDF, doc,docx, JPG and other files, and the size can't exceed 20M",
    selectCategory: 'Please select the category',
    selectMaterial: 'Please select the material name',
    uploadedFileSize: "Uploaded file size can't exceed 20MB",
    cantExceed20M: "Uploaded file size can't exceed 20MB",
    cantExceed500kb: "Uploaded file size can't exceed 500kb",
    uploadSuccessfully: 'Upload successfully',
    errorFileUploaded: 'Error in updating file uploaded, please reupload'
  },
  videoRecord: {
    participants: 'Participants',
    uploadTime: 'Upload time',
    download: 'Play, download',
    enterDetails: 'Please enter the details',
    record: 'Record',
    haveAgreed: 'Have agreed',
    haveRejected: 'Have rejected',
    scanQRCode:
      'Your mediation has been completed, if there is no objection to the Mediation Transcript/Mediation Agreement, please scan the QR code with WeChat, go to WeChat small program, carry out handwritten signature confirmation operation to protect your legitimate interest',
    limitedString: 'Length in 2 to 5 characters',
    selectProvincial: 'Please select the provincial city district',
    selectGender: 'Please select the gender',
    enterDetailedAddress: 'Please enter the detailed address'
  },
  bookMeeting: {
    mediator2: 'Mediator',
    mediator: 'Mediator(video mediation supports up to 8 people)',
    petitionAgent: 'Petition agent',
    mediationTime: 'Mediation time',
    now: 'Now',
    reservationTime: 'Reservation time',
    selectDate: 'Select a date',
    selectTime: 'Select a time',
    mediationLocation: 'Mediation location',
    reservationAddress: 'Reservation address',
    confirm: 'Confirm',
    cancel: 'Cancel',
    plselectDate: 'Please select the date',
    plselectTime: 'Please select the time',
    selectOneApplicant: 'Please select at least one applicant',
    selectOneRespondent: 'Please select at least one respondent',
    selectOneParty: 'Please select at least one party',
    requiredEnterTel:
      'The party is required to enter the Tel before he/she can be booked for the mediation',
    reservationSucceed: 'Reservation succeed',
    mediationSucceed: 'Mediation succeed!',
    noRealNameAuthentication: '(No real name authentication)',
    invalidDocument: 'Invalid document',
    invalidReason:
      'Nullify the current instrument, which will be discarded. The mediator is required to regenerate and sign the document. Invalid reason：',
    invalidPlaceholder: 'Please enter the reason for invalidation',
    orPreview: 'The file cannot be previewed',
    insuccess: 'Invalid success！',
    infail: 'Invalid failure！'
  },
  workbench: {
    HasBeenCanceled: 'Has been canceled',
    accountType: 'Account type',
    continue: 'Continue',
    organizationsRepresentative: "Organization's representative",
    physicalDiscomfort: 'Physical discomfort',
    muchWork: 'Much work recently',
    noRelevantExperience: 'Individuals have no relevant experience',
    notSuitableOrganization: "Dispute isn't suitable for this organization",
    next: 'Next, fill in the mediation plan',
    applicant: 'Applicant',
    respondent: 'Respondent',
    legalRepresentative: 'Legal representative',
    enterLegalRepresentative: 'Please enter the legal representative.',
    enterOrganizationRepresentative:
      'Please enter the organization representative',
    socialCreditCode: 'Social credit code',
    enterSocialCreditCode: 'Please enter the social credit code',
    IDIncorrect: 'Please enter ID number',
    enterTel: 'Please enter your Tel',
    tel: 'Tel',
    tel2: 'Tel: ',
    telIncorrect: 'Tel is incorrect',
    email: 'Email address：',
    email2: 'Email address',
    address: 'Address',
    enterEmail: 'Please enter email address',
    formatIncorrect: 'Email address format is incorrect',
    enterAgentsName: "Please enter the agent's name",
    enterAgentsTel: "Please enter the agent's Tel",
    enterAgentsIDNumber: "Please enter the agent's ID number",
    enterIDNumber: 'Please enter 18-digit ID number',
    enterRespondentsName: "Please enter the respondent's name",
    enterCorrectTel: 'Please enter the correct Tel',
    mainFacts: 'Main facts, contentious matters: ',
    followingAgreements:
      'After mediation, reached to the following agreements: ',
    writieMediationOrganization:
      'The parties have agreed in writing with the mediation organization applying non-objection mediation recognition system. The following mediation plan is proposed for this dispute: ',
    mediationProcess: 'Mediation process: ',
    afterMediation:
      'After mediation, the non-controversial facts are as follows: ',
    haveSigned: 'Have signed',
    residenceAddress: 'Residence address',
    residenceAddress2: 'Residence address: ',
    organizationAddress: 'Organization address',
    organizationAddress2: 'Organization address: ',
    groupAddress: 'Organization address',
    whetherToContinue:
      "It is fixed-line telephone, the instrument can't be received and signed after its initiation, whether to continue?",
    sendSave: 'Send the save operation at the same time, whether to continue?',
    enterCorrectInformation:
      "Information verification didn't pass, please enter the correct information",
    save: 'Save while sending succeessfully, whether to continue?',
    errorInSigning: 'Error in signing'
  },
  status: {
    detailedReasons: 'Detailed reasons: ',
    other: 'others',
    reason: 'reason',
    confirmMediationAgreement: 'Both parties confirm the mediation agreement',
    dontReachMediationAgreement:
      "The parties don't reach a mediation agreement",
    applicantWantMediation: "Applicant doesn't want mediation",
    respondentWantMediation: "The respondent doesn't want mediation",
    mediationSucceed: 'Mediation succeed!',
    selectStatus: 'Please select a status',
    plaintiffsName: "Plaintiff's name",
    plaintiffsContactNumber: "Plaintiff's contact number",
    defendantsName: "Plaintiff's contact number",
    DefendantsContactNumber: "Defendant's contact number",
    mediationNotes: 'Mediation Notes: ',
    fillMediationNotes: 'Please fill in the mediation notes',
    didntAgree: "The parties didn't reach an agreed mediation agreement",
    applicantDoesntWantMediation: "The applicant doesn't want mediation",
    respondentDoesntWantMediation: "The respondent doesn't want mediation",
    plaintiffRequestsForClosure: 'Plaintiff requests for closure',
    defendantRequestsForClosure: 'Defendant requests for closure',
    cantDeliverToDefendant: "Can't deliver to the defendant."
  },
  judicial: {
    claimMatters: 'Claim matters',
    claimMatters2: 'Claim matters: ',
    factsAndReasons: 'Facts and reasons',
    factsAndReasons2: 'Facts and reasons: ',
    courtAcceptedApplication: 'Facts and reasons: ',
    selectCourt: 'Please select the court',
    caseType: 'Case type',
    selectCaseType: 'Please select a case type',
    selectCause: 'Please select the cause',
    causeAction: 'Cause of action: ',
    civil: 'Civil',
    guangzhou: 'Guangzhou Internet Court',
    selectCourtCase: 'Please select the court and case type',
    reselect:
      'There is no cause under the court and case type, please reselect',
    entrustedAgent: 'Entrusted agent',
    turnOnSpeechRecognition: 'Turn on the automatic speech recognition',
    description:
      "Description: After the successful mediation, the system will automatically apply to the court for withdrawing the case. The application won't affect the subsequent application for judicial confirmation or the mediation agreement.",
    description2:
      'I agree that the judicial authorities serve me the electronic delivery of legal documents (including but not limited to judicial confirmation, civil adjudications or civil mediation agreements) on the Guangzhou court online dispute resolution platform concerning Hong Kong and Macao platform. The delivery address shall be subject to my completion of the mediation agreement.'
  },
  caseInfo: {
    sureToDelete: 'Are you sure to delete?',
    duringMediation:
      'During mediation, deleting the parties would cause inconsistency with the parties in the instrument had been sent'
  },
  partyBook: {
    applicant: 'Applicant 1',
    mainFacts: "The main facts, disputed matters can't be blank",
    uponMediation:
      "Upon mediation, the following agreement which is voluntarily reached can't be blank",
    description1:
      "Description: 1. After the mediation succeed, the system will automatically apply to the court for case withdrawal. It won't affect the subsequent application to the court for judicial confirmation or the issuance of  the mediation certificate.",
    description2:
      '2. I agree that the judiciary deliver electronic legal instruments (including but not limited to judicial confirmation civil decisions or civil mediation agreements) to me from the Guangzhou court online dispute resolution platform concerning Hong Kong and Macao platform. The address shall be subject to the completion of the mediation agreement.',
    mediationProgramme: "Mediation programme can't be blank",
    haveObjections: 'Have objections',
    agreeSave: 'Agree and save',
    dissidentsName: "Please enter the dissident's name",
    dissident: 'Dissident',
    incorrectEmailAddress: 'Incorrect email address',
    mailingAddress: 'Mailing address',
    objectionsDescription: 'Objections description',
    commitmentMediationProgramme:
      'Commitment of the no-objection mediation programme',
    statementProtest: 'Statement of protest',
    requiredFields: 'Required fields are not filled in'
  },
  //   infocenter
  serviceinfo: {
    personalCenter: 'Personal center',
    individualImformation: 'Individual imformation',
    edit: 'Edit',
    avatar: 'Avatar',
    basicInformation: 'Basic information',
    politicalStatus: 'Political status',
    IDNumber: 'ID number: ',
    uploadIDCard: 'Upload ID card',
    front: 'Front',
    reverseSide: 'Reverse side',
    name: 'Name',
    gender: 'Gender',
    dateOfBirth: 'Date of birth: ',
    contactPhone: 'Contact phone',
    contactEmail: 'Contact email',
    landline: 'Landline',
    degreeOfEducation: 'Degree of education',
    occupationInformation: 'Occupation information',
    areasOfExpertise: 'Areas of expertise',
    qualificationCertificate: 'Qualification certificate',
    uploadTheCertificate: 'Upload the certificate',
    occupation: 'Occupation',
    workingOrganization: 'Working organization',
    workAddress: 'Work address',
    detailAddress: 'Detail address',
    timeToStartWorking: 'Time to start working',
    careerExperience: 'Career experience',
    platformFunction: 'Platform function',
    typeOfFunction: 'Type of function',
    serviceOrganization: 'Service organization',
    serviceArea: 'Service area',
    delete: 'Delete',
    add: 'Add',
    save: 'Save',
    phoneNumberFormatError: 'Phone number format error',
    wrongIDNumberFormat: 'Wrong ID number format',
    enterName: 'Please enter the name',
    enterPhoneNumber: 'Please enter the telephone number',
    selectFunctionType: 'Please select a function type',
    selectServiceOrganization: 'Please select a service organization',
    selectServiceArea: 'Please select a service area',
    CommunistPartyofChina: 'Member of Communist Party of China',
    ProbationaryPartyMembers: 'Probationary party members',
    leagueMember: 'League member',
    MDC:
      'Member of the MDC（The Revolutionary Committee Of The Chinese Kuomintang）',
    CDL: 'Member of the CDL（China Democratic League）',
    CDNCA:
      'Member of the CDNCA（China Democratic National Construction Association）',
    DPP: 'Member of the DPP（Democratic Progressive Party）',
    CPWDP:
      "Member of the CPWDP（Chinese Peasants' and Workers' Democratic Party）",
    thePublicParty: 'To members of the public party',
    JiusanSocietyMembers: 'the Jiusan Society Members',
    TDSL: 'Member of the TDSL（Taiwan Democratic Self-Government League）',
    nonpartyPersonage: 'Nonparty personage',
    ordinaryResident: 'Ordinary resident',
    editPersonalInformation: 'Edit personal information successfully',
    militaryOfficerCard: 'Military Officer Card',
    passport: 'Passport'
  },
  setaccount: {
    accountType: 'Account type',
    accountSetting: 'Account setting',
    newAccountNumber: 'New account number',
    newAccountNumber2: 'New account number(Mobile phone number)',
    enternewAccountNumber: 'Enter new account number(Mobile phone number)',
    mobilePhoneNumber: 'Mobile phone number',
    verificationCode: 'Verification code',
    getTheVerificationCode: 'Get the verification code',
    enterNewAccount: 'Please enter the new account',
    enterTheSMSVerificationCode:
      'Please enter the SMS/email verification code.',
    resend: 'Resend',
    modifyPasswordSuccessfully:
      'Modify phone number successfully,it will jump to the home page'
  },
  setpwd: {
    modifyPassword: 'Modify password',
    oldPassword: 'Old password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    inconsistentPasswordsEntered: 'Inconsistent passwords entered two times',
    pleaseEnter:
      'Please enter 8-16 digits, including upper and lower case letters, numbers, and special symbols',
    enterOldPassword: 'Please enter the old password',
    enterNewPassword:
      'Please enter 8-16 digits, including upper and lower case letters, numbers, and special symbols',
    enterPasswordAgain: 'Please enter the password again',
    modifyPasswordSuccessfully:
      'Modify password successfully,it will jump to the home page',
    organizationInformation: 'Organization information'
  },
  orginfo: {
    organizationsName: "Organization's name",
    administrativeLevel: 'Administrative level',
    administrativeLevel2: 'Administrative level: ',
    pleaseSelect: 'Please select',
    superiorOrganization: 'Superior organization',
    superiorOrganization2: 'Superior organization: ',
    telephoneLandline: 'Telephone landline',
    telephoneLandline2: 'Telephone landline: ',
    groupAddress: "Organization's address",
    groupAddress2: "Organization's address: ",
    affiliatedLocation: 'Please select the affiliating area ',
    organizationType: 'Type of organizations',
    organizationCode: 'Organization code',
    organizationCode2: 'Organization code: ',
    organizationCodeCertificate: 'Organization code certificate',
    provincial: 'Provincial',
    municipalLevel: 'Municipal level',
    districtCountyLevel: 'District/County level',
    court: 'Court',
    generalOrganization: 'General organization',
    selectOrganizationType: 'Please select the organization type',
    enterTheOrganizationAddress: 'Please enter the organization address',
    enterTheTelephoneLandline: 'Please enter the telephone landline',
    selectAffiliatingArea: 'Please select the affiliating area ',
    editingSucceed: 'Organization information editing succeed'
  },
  //   statAnalysis
  platformap: {
    statisticalAnalysis: 'Statistical analysis',
    disputeMap: 'Dispute map',
    selectDate: 'Select a date',
    startDate: 'Start date',
    endingDate: 'Ending date',
    inquire: 'Inquire',
    selectCity: 'Select city',
    pleaseSelectCity: 'Please select a city',
    export: 'Export',
    allStreets: 'All streets',
    street: 'Street',
    numberOfDisputeMediationInTheStreet:
      'Number of dispute mediation in the street',
    numberOfDisputeMediation: "Organization's number of dispute mediation",
    TrendOfGuangzhou: 'mediation trend of HaiKou',
    number: 'Number',
    organizationsName: "Organization's name",
    administrator: 'Administrator',
    contactWay: 'Contact way',
    mediatorsWithinTheEstablishment: 'Mediators within the establishment',
    numberOfDisputes: 'Number of disputes',
    previousPage: 'Prev',
    nextPage: 'Next',
    numberOfUserRegistrations: 'Number of user registrations',
    numberOfMediationOrganizations: 'Number of mediation organizations',
    numberOfMediators: 'Number of mediators',
    numbeMediationCases: 'Number of mediation cases',
    numberOfSuccessfulMediation: 'Number of successful mediation',
    failedMediationsAmount: 'The number of failed mediations',
    numberOfJudicialConfirmations: 'Number of judicial confirmations',
    totalNumberOfLitigationCases: 'Total number of litigation cases',
    totalConsultations: 'Total consultations',
    mediate: 'Mediate',
    consult: 'Consult',
    judicial: 'The judicial confirmation',
    litigation: 'litigation',
    arbitration: 'The arbitration'
  },
  userstatistics: {
    userStatisticsList: 'User statistics list',
    totalVisits: 'Total visits',
    numberOfRegisteredUsers: 'Number of registered users',
    serviceStaff: 'Service staff',
    serviceOrganization: 'Service organization',
    accessingUserVolumeStatistics: 'Accessing user volume statistics',
    statisticsOfRegisteringUsers: 'Statistics of registering users',
    serviceStaffStatistics: 'Service staff statistics',
    resourceMap: 'Resource map',
    thematicAnalysisOfDisputes: 'Thematic report'
  },
  disputesubject: {
    typedCases: 'Typed cases',
    analysisOfConsultationTrend: 'Analysis of consultation trend',
    analysisOnMediationCasesTrend: "Analysis on mediation cases' trend",
    analysisOfTheMediationCases:
      "Analysis of the mediation cases' number in the street",
    parameterDimensionAnalysis:
      'Parameter dimension analysis of mediation cases',
    applicantRoleAnalysis: 'Applicant role analysis',
    mediationStatusAnalysis: 'Mediation status analysis',
    analysisOfMediationResult: 'Analysis of mediation result',
    variousTypesOfDisputeMediation:
      'Data on various types of dispute mediation in various streets',
    selectOneDisputeType: 'Please select at least one dispute type ',
    disputesHaveBeenSelected: '1 type of disputes have been selected',
    numberOfConsultations: 'The number of consultations',
    numberOfCases: 'Number of cases converted from consultation to mediation',
    proportion: 'Proportion of consultation transfer mediation',
    waitingForAcceptance: 'Waiting for acceptance',
    waitingMediation: 'Waiting for mediation',
    inMediation: 'In mediation',
    ended: 'Ended',
    individual: 'Individual',
    legalPerson: 'Legal person',
    unincorporatedOrganization: 'Unincorporated organization',
    closed: 'Closed',
    mediationSucceed: 'Mediation succeed',
    mediationFailed: 'Mediation failed',
    withdrawCase: 'Withdraw the case'
  },
  //   admin
  role: {
    rolePermission: 'Role permission',
    rolePermission2: 'Role permission: ',
    roleManagement: 'Role management',
    roleType: 'Role type: ',
    roleType2: 'Role type',
    newRoleName: 'New role name',
    roleName: 'Role name',
    roleName2: 'Role name: ',
    creater: 'Creater',
    creationTime: 'Creation time',
    remark: 'Remark',
    remark2: 'Remark: ',
    operate: 'Operate',
    view: 'View',
    modify: 'Modify',
    counselor: 'Counselor',
    customerService: 'Customer service',
    judge: 'Judge',
    newOrganization: 'New organization'
  },
  roleEdit: {
    roleInformation: 'Role information',
    roleCode: 'Role code: ',
    selectOnePermission: 'Please select at least one permission',
    enterRoleName: 'Please enter the role name',
    enterRoleCode: 'Please enter the role code',
    enterRoleType: 'Please enter the role type',
    normalUser: 'Normal user',
    modifyingRuleSucceed: 'Modifying rule succeed',
    addingRoleSucceed: 'Adding role succeed'
  },
  organizationEdit: {
    organizationManagement: 'Organization management',
    organizationInformation: 'Organization information',
    organizationsName: "Organization's name",
    organizationType: 'Type of organizations',
    administrativeLevel: 'Administrative level',
    organizationsContacts: "Organization's contacts",
    organizationsContacts2: "Organization's contacts: ",
    mediationType: 'Type of mediation',
    mediationType2: 'Type of mediation: ',
    contactsTelephone: "Contacts' telephone",
    contactsTelephone2: "Contacts' telephone: ",
    superiorOrganization: 'Superior organization',
    organizationCode: 'Organization code',
    telephoneLandline: 'Telephone landline',
    groupAddress: "Organization's address",
    organizationCertificate: 'Organization certificate: ',
    enterOrganization: 'Please enter the organization name',
    enterOrganizationalContact: 'Please enter an organizational contact',
    enterContactsPhone: "Please enter the contact's phone number",
    selectAdministrativeLevel: 'Please select the administrative level',
    selectOrganizationType: 'Please select the organization type',
    selectMediationType: 'Please select a mediation type',
    enterTheTelephoneLandline: 'Please enter the telephone landline',
    selectTypeOfDispute: 'Please select the type of dispute',
    selectOrganizationAddress: 'Please select the organization address',
    lawOffice: 'Law office',
    addingOrganizationSucceed: 'Adding organization succeed',
    modifyingOrganizationSucceed: 'Modifying organization succeed'
  },
  accountEdit: {
    accountManagement: 'Account management',
    workersAccountInformation: "Worker's account information",
    basicInformation: 'Basic information',
    politicalStatus: 'Political status',
    contactEmail: 'Contact email',
    degreeOfEducation: 'Degree of education',
    dateOfBirth: 'Date of birth: ',
    occupationInformation: 'Occupation information',
    separateWithCommas:
      'Please separate with commas, such as: marital disputes, distribution of property',
    qualificationCertificate: 'Qualification certificate',
    typeOfOccupation: 'Type of occupation',
    workAddress: 'Work address',
    careerExperience: 'Career experience',
    platformFunctionRoles: 'Platform function roles',
    affiliatedOrganization: 'Affiliated organization',
    selectSubsidiaryOrganization: 'Please select the subsidiary organization',
    affiliatedArea: 'Affiliated area',
    selectArea: 'Please select the area',
    selectOrganization: 'Please select an organization',
    separateAreasOfExpertise: 'Please separate areas of expertise in commas',
    wrongIDNumberFormat: 'Wrong ID number format',
    enterName: 'Please enter the name',
    enterPhoneNumber: 'Please enter the telephone number',
    selectRoleType: 'Please select a role type',
    selectRoleName: 'Please select a role name',
    modifyingWorkerSucceed: 'Modifying worker succeed',
    addingWorkerSucceed: 'Adding worker succeed'
  },
  account: {
    accountStatus: 'Account status',
    accountStatus2: 'Account status: ',
    inUse: 'In use',
    deactivated: 'Deactivated',
    deactivation: 'Deactivation ',
    startUsing: 'Start using',
    paused: 'Paused',
    noData: 'No data found',
    statusModificationSucceed: 'Status modification succeed',
    addAccount: 'Add account'
  },
  abilityTempleEdit: {
    newConstruction: 'New construction template',
    templateName: 'Template name',
    assessmentCycle: 'Assessment cycle',
    applicableObjects: 'Applicable objects',
    indexWeight: 'Index weight',
    sumWeights: '(The sum of weights should be 100%)',
    assessmentIndicators: 'Assessment indicators',
    indexDescription: 'Index description',
    index: 'Index',
    enterWeights: 'Please enter the weights (example: 20%)',
    getProcessingRate:
      'Processing rate = Number of cases mediated/(number of cases mediated + number of cases being mediated)',
    getSuccessRate:
      'Success rate = Number of cases mediated successfully/numbers of cases mediated',
    assessmentResult: 'Assessment result',
    score: 'Score',
    grade: 'Grade',
    example: '(Example: 0~50)',
    enterTemplateName: 'Please enter the template name',
    selectAssessmentCycle: 'Please select the assessment cycle',
    selectApplicableObject: 'Please select the applicable object',
    processingRate: 'Processing rate',
    SuccessRateOfMediated: 'Success rate of mediated cases during the cycle',
    satisfaction: 'Satisfaction',
    partiesSatisfaction:
      "The parties' satisfaction about the mediation process during assessment cycle",
    successRate: 'Success rate',
    duringTheAssessmentCycle:
      'Success rate of mediated cases during the assessment cycle',
    fillInformation: 'Please fill in the template information completely.'
  },
  abilityTemple: {
    competencyAssessmentAnalysis: 'Competency assessment analysis',
    whetherContinue:
      'This operation will permanently delete the file, whether to continue?',
    deletionCanceled: 'Canceled deletion'
  },
  //  consultant
  finishDetail: {
    completedConsultation: 'Completed consultation',
    consultationDetails: 'Consultation details',
    inAConversation: 'In a conversation with XXX',
    caseNo: 'Case number',
    caseType: 'Case type',
    viewDisputeDetails: 'View dispute details',
    consultationIsEnd: 'Consultation is end',
    pleaseEnter: 'Please enter the content',
    consultationTime: 'Consultation time',
    MondayToFriday: '(Monday to Friday 9:00-18:00)',
    listOfEvidence: 'List of evidence',
    attachmentsDownloadSucceeded: 'Attachments download succeeded'
  },
  detail: {
    calculator: 'Calculator',
    sendingFiles: 'Sending files',
    clickUpload: 'Click to upload',
    canBeUploaded: 'Only doc/docx/png/jpg/txt files can be uploaded',
    total: 'Total (0)',
    inVoice: 'In voice',
    voiceNotSupported: 'Voice-to-text is not supported in the current browser',
    reuploadFile: 'Please re-upload the file',
    uploading: 'Uploading, please wait',
    errorFileUploaded:
      'An error occurred updating the uploaded file, please upload again',
    uploadSuccessfully: 'Upload successfully',
    selectFirst: 'Please select a file first',
    mediated: 'Mediated'
  },
  //   dtuMediation
  peoMediation: {
    applicationNotice: 'Application notice',
    tip1:
      '1. Please register the information truthfully according to the actual situation of the dispute, in order to serve you better, please confirm that the information completed is correct and complete.',
    tip2:
      '2. Within three days of your application for mediation, the administrator of the mediation organization to decide whether to accept and assign the mediator, who will contact you by phone. It will use SMS to notify during the whole process, please keep the phone open.',
    tip3:
      '3. An agent is a person who carries out agency activities in the name of the one represented. If you fill in your agent. The agent will carry out the civil activities related to this mediation on your behalf within the scope of your authorization. Fill in the details of the dispute',
    fillDisputeDetails: 'Fill in the dispute details',
    fillApplicantsInformation: "Fill in the applicant's information",
    fillRespondentInformation: 'Fill in the respondent information'
  },
  onlineMediation: {
    fillConsultationInformation: 'Fill in the consultation information',
    selectCounselor: 'Select a counselor',
    evaluateTheCounselor: 'End consultation and evaluate the counselor'
  },
  applyAssess: {
    submitAnApplication: 'Submit an application',
    applicationForAssessmentReport: 'Application for assessment report',
    assessmentReportGeneration: 'Assessment report generation',
    viewEvaluationReport: 'View the evaluation report'
  },
  //   login
  loginstaff: {
    signInWithPhone: 'Sign in with phone number',
    forgotPassword: 'Forgot your password?'
  },
  findpwd: {
    enterPhoneNumber: 'Please enter the telephone number',
    enterEmail: 'Please enter the email',
    enterVerificationCode: 'Please enter the verification code',
    enterTheSMSVerificationCode: 'Please enter the SMS verification code',
    enterTheEmailVerificationCode: 'Please enter the Email verification code',
    getSMSVerification: 'Get SMS verification code',
    getEmailVerification: 'Get Email verification code',
    enterNewPassword:
      'Please enter 8-16 digits, including upper and lower case letters, numbers, and special symbols',
    enterNewPasswordAgain: 'Please enter the new password again',
    verifyPhoneNumber: 'Verify phone number',
    verifyEmail: 'Verify email',
    resetPassword: 'Reset password',
    pleaseEnter:
      'Please enter 8-16 digits, including upper and lower case letters, numbers, and special symbols',
    reenterPassword:
      'The password entered two times is inconsistent, please re-enter',
    passwordResetSucceeded:
      'Password reset succeeded, jump to login page after 3 seconds',
    phoneNumberFormatError: 'Phone number format error',
    emailFormatError: 'Email format error',
    enterGraphicalVerificationCode:
      'Please enter the graphical verification code',
    graphicalVerificationCodeError: 'Graphical verification code error',
    resend: 'Resend',
    phoneNumberOrEmailFormatError: 'Phone number or Email format error'
  },
  //   register
  register: {
    registerWithPhoneNumber: 'Register with phone number',
    registerWithEMail: 'Register with email',
    enterPhoneNumber: 'Please enter the telephone number',
    enterTheSMSVerificationCode: 'Please enter the SMS verification code',
    getTheVerificationCode: 'Get the verification code',
    enterThePassword: 'Please enter the password',
    agree: 'I agree',
    resend: 'Resend',
    register: 'Register',
    emailFormatError: 'Email format error',
    activateLogin:
      'The message has been sent, please go to your mailbox to activate the login',
    registerWithEMailOrPhoneNumber:
      'Please enter the telephone number or phone number'
  },
  registersuccess: {
    registrationIsCompleted: 'Registration is completed!',
    completeRealNameCertification: 'Complete real name certification',
    registerAccount: 'Dispute registration',
    toRegister: 'Fill in the phone number password to register',
    fillTheCaseInformation:
      'Fill in the case information and upload the evidence material',
    onlineMediation: 'Online mediation',
    organizeOnlineVideoMediation:
      'Mediators know the dispute details and organize online video mediation',
    partiesReachMediationAgreement: 'The parties reach a mediation agreement',
    ApplyJudicialConfirmation: 'Application for judicial confirmation',
    judicialConfirmation:
      'Joint application for judicial confirmation by both parties',
    enterIDNumber: 'Please enter the 2nd-generation ID number',
    realNameCertificationSucceed:
      'Congratulations, real name certification succeed!',
    viewTheInformation:
      'You can view the information after real name certification in personal center'
  },
  //   userCenter
  evlaLetter: {
    userReviews: 'User reviews',
    trainingMaterials: 'Training materials',
    starRating: 'Star rating',
    numberOfAssessments: 'Number of assessments',
    numberOfAssessments2: 'Number of assessments: ',
    caseNo: 'Case number',
    assessorsName: "Assessor's name",
    assessmentTime: 'Assessment time',
    starLevel: 'Star level',
    starLevel2: 'Star level: ',
    content: 'Content'
  },
  ace_api: {
    noCameraDetected:
      'No camera detected, please detect if there is a audio and video device',
    noCamera: 'No camera detected',
    verificationSucceed: 'Verification succeed',
    browserDoesntSupport:
      "Your browser doesn't support getting users for the moment"
  },
  info: {
    basicInformation: 'Basic information',
    currentAvatar: 'Current avatar: ',
    fileLimited:
      'Only PNG, JPG picture files are supported, and should be less than 1M',
    realName: 'Real name: ',
    currentResidenceArea: 'Current residence area: ',
    detailAddress: 'Detail address:',
    permanentResidenceAddress: 'Permanent residence address: ',
    onlyBeFormat: 'Upload avatar images can only be in JPG or PNG format',
    cantExceed1MB: "Upload avatar picture size can't exceed 1MB!",
    male: 'Male',
    female: 'Female',
    other: 'Other',
    enterIDNumber: 'Please enter ID number'
  },
  security: {
    yourSecurityLevel: 'Your security level',
    securityLevel: 'Security level',
    completeAllBindings: 'Complete all bindings to improve account security',
    identityAuthentication: 'Identity authentication',
    improveAccountSecurity:
      'Improve account security and trust level, after certification will not be able to modify authentication information',
    bindPhone: 'Bind your phone',
    improveSecurity:
      'Bind phone can help improve security and retrieve password',
    bindEmail: 'Bind your email',
    bindEmailHelp:
      'Binding email can help improve security and ensure the notification of information',
    modifyPassword: 'Modify password',
    modifyMail: 'Modify email',
    newMail: 'New email',
    originalPassword: "The original password can't be blank",
    originalPas: 'Original password',
    enterOriginalPas: 'Please enter the original password',
    enterMail: 'Please enter the email',
    newPas: 'New password ',
    newPasswordCantBeBlank: "The new password can't be blank",
    confirmPasswordBlank: "Confirm password can't be blank",
    modifyBindingPhone: 'Modify binding phone number',
    moreThan8Digits:
      'Settings contain numbers and letters, which should be more than 8 digits in length',
    enterPasswordAgain: 'Please enter the password again',
    inconsistentPasswordsEntered: 'Inconsistent passwords entered two times',
    enterPhoneNumber: 'Please enter the telephone number',
    telFormatIncorrect: 'The phone number format is incorrect',
    certified: 'Certified',
    setUp: 'settings',
    enterCorrectEmailAddress: 'Please enter the correct email address',
    goauthentication: 'Go authentication',
    validationDidntPass: "Form validation didn't pass",
    cantBeTheSameAsTheOriginals:
      "The new phone number can't be the same as the original's",
    hasBeenCertified: 'Has been certified by real name',
    newPhone: ' New phone',
    modificationSucceed: 'Modification succeed',
    score: 'score'
  },
  centerTwo: {
    inProgress: 'The assessment report is in progress',
    application: 'Application for assessment report completed',
    assessmentProgress: 'Assessment progress',
    noAssessmentRequested: 'No assessment requested',
    applicationForAssessmentReport: 'Application for assessment report',
    generateTheAssessmentReport: 'Generate the assessment report',
    viewEvaluationReport: 'View the evaluation report',
    noAssessmentReportRequested: 'No assessment report requested',
    assessmentReport: 'The assessment report is in the application process',
    initiateTheAssessment: 'Initiate the assessment',
    judicialConfirmation: 'Judicial confirmation'
  },
  centerSix: {
    enterQueryPassword: 'Enter the query password',
    queryPassword: 'Query password',
    enterTheQueryPassword: 'Please enter the query password',
    caseStatus: 'Case status',
    causeActionType: 'Cause of action type',
    courtForApplication: 'Court for application',
    applicantsAppeal: "Applicant's appeal",
    applicationForMediation: 'Details of application for mediation',
    mediationApplicationApplication: 'Application of mediation application',
    waitingForConfirmation: 'Waiting for confirmation',
    accepting: 'Accepting',
    confirmEffectiveness: 'Confirm the effectiveness',
    filingProgressInquiry: 'Filing progress inquiry'
  },
  centerSeve: {
    ApplyJudicialConfirmation: 'Application for judicial confirmation',
    consultationProgress: 'Consultation progress'
  },
  centerOne: {
    viewRecords: 'View records',
    manualConsultation: 'Manual consultation',
    fillApplication: 'Fill in the application',
    consultationEnds: 'Consultation ends',
    initiateTheConsultation: 'Initiate the consultation',
    applicationForLitigation: 'Application for litigation'
  },
  centerFour: {
    proceedingDetails: 'Proceeding details',
    registrationTime: 'Registration time',
    fileACaseOnline: 'Apply to file a case online',
    waitingForAcceptance: 'Waiting for acceptance',
    filingSucceed: 'Filing succeed',
    accessToLitigation: 'Access to litigation',
    detailsOfJudicialConfirmation: 'Details of judicial confirmation'
  },
  centerFive: {
    registrationTime: 'Registration time: '
  },
  registration: {
    disputeList: 'Dispute registration list',
    addDispute: 'add dispute',
    myDispute: 'my dispute registration'
  },
  //   mediator
  judicialConfirm: {
    naturalPerson: 'Natural person: ',
    legalPerson: 'Legal person: ',
    unincorporatedOrganization: 'Unincorporated organization: ',
    organiztionsName: "Organiztion's Name",
    ApplyJudicialConfirmation: 'Application for judicial confirmation',
    basicInformation: 'Basic information',
    courtAcceptedApplication: 'The court accepting the application',
    caseType: 'Case type',
    caseType2: 'Case type: ',
    partysBasicInformation: "The party's basic information",
    required: 'Required',
    instrumentDeliveryAddress: 'Instrument delivery address',
    instrumentDeliveryAddress2: 'Instrument delivery address: ',
    fillInstrumentDeliveryAddress:
      'Please be sure to fill in the Instrument delivery address',
    notes:
      'Note: Both the institutional code and the registration number of the legal and the unincorporated organization take the unified credit code in the mediation',
    fillOrganizationsName: "Please fill in the organization's name",
    organizationsNature: "Organization's nature: ",
    organizationCode: 'Organization code',
    registrationNumber: 'Registration number: ',
    enterRegistrationNumber: 'Please enter registration number',
    legalRepresentative: 'Legal representative',
    principalPersonInCharge: 'Principal person in charge',
    principalPersonInCharge2: 'Principal person in charge: ',
    organizationCodeFormatError: 'Organization code format error',
    registrationNumberFormatError: 'Registration number format error',
    onlineDelivery: 'Online delivery',
    mailDelivery: 'Mail delivery',
    selectResidentArea: 'Please select the resident area',
    selectOrganizationAddress: 'Please select the organization address',
    enterAddress: 'Please enter the instrument delivery address',
    enterOrganiztionsName: "Please enter the organization's name",
    enterRequest: 'Please enter the request',
    operateAgain:
      'The form information is entered incorrectly, please reoperate',
    evidenceCompletedOrBlank:
      'Each piece of evidence must be completed or blank',
    queryPasswordEnter: 'Query password, must enter',
    judicialConfirmationSubmissionSucceed:
      'Judicial confirmation submission succeed',
    mediationAgreement: 'Mediation agreement',
    certificateOfJudicialConfirmation: 'Certificate of judicial confirmation',
    applicationJudicialConfirmation: 'Application for judicial confirmation',
    partysCertification: "The party's certification",
    fillIDNumber: 'Please fill in the ID number',
    fillPhoneNumber: 'Please fill in phone number'
  },
  detailold: {
    pendingMediationCases: 'Cases to be mediated',
    completedCases: 'Completed case',
    disputeDetails: 'Dispute details',
    reserveMeeting: 'Reserve meeting',
    workbench: 'Workbench',
    reassign: 'Reassign',
    mediationAgreement: 'Mediation agreement',
    NoobjectionMediation: 'No-objection mediation programme',
    NoncontroversialFactsConfirmation:
      'Non-controversial factual confirmation agreement',
    applicationJudicialConfirmation: 'Application for judicial confirmation',
    electronicFiles: 'Electronic files',
    followUpPhase: 'Follow-up phase',
    mediationStatus: 'Mediation status',
    applicationForAssessmentReport: 'Application for assessment report',
    mediationRecords: 'Mediation records',
    participant: 'Attendees',
    mediationName: 'Name of mediation',
    enterVideo: 'Enter the video',
    assessmentReport: 'Assessment report',
    uploadFiles: 'Upload files',
    assessmentReportBook: 'Assessment report',
    peopleMediation: "People's mediation",
    administrativeMediation: 'Administrative mediation',
    arbitrationMediation: 'Arbitration mediation',
    judicialMediation: 'Judicial mediation',
    commercialMediation: 'Commercial mediation',
    lawyerMediation: 'Lawyer mediation',
    notaryMediation: 'Notary mediation',
    professionalMediation: 'Professional mediation',
    industryMediation: 'Industry mediation',
    deletingThePeople: 'Whether to continue deleting the people',
    continueDeletingfile: 'Whether to continue deleting the file',
    deletionCanceled: 'Canceled deletion'
  },
  detailRecord: {
    playDownload: 'Play, download',
    clickPlay: 'Click to play or right-click the link to save as'
  },
  applicantdata: {
    socialCreditCode: 'Social credit code',
    enterUnifiedSocialCreditCode: 'Please enter the unified social credit code',
    fillOrganizationsName: "Please fill in the organization's name",
    fillApplicantsName: "Please fill in the applicant's name",
    socialCreditCodeError: 'Social credit code input error',
    enterOrganiztionsName: "Please enter the organization's name",
    enterOrganization: 'Please enter the organization name',
    enterOrganizationRepresentative:
      "Please enter the organization's representative",
    fillRespondentsName: "Please fill in the respondent's name"
  },
  //   organcenter
  distribution: {
    mediator1: 'Mediator: ',
    organizationsManagementCenter: "Organization's management center",
    caseAssignment: 'List of case assignment',
    enterNameNumberCase: 'Please enter your name/number/dispute type',
    search: 'Search',
    disputeType: 'Dispute type',
    expand: 'Expand',
    hide: 'Hide',
    registrationTime: 'Registration time',
    sure: 'Sure',
    startDate: 'Start date',
    endingDate: 'Ending date',
    searchResults: 'Search results',
    disputeNo: 'Dispute number: ',
    mediator: 'Mediator',
    accept: 'Accept',
    notAccept: 'Not accepted',
    allotMediators: 'Allocation of mediators',
    reallotMediators: 'Redistribution of mediators',
    transferMediationOrganization: 'Transfer of mediation institutions',
    mediationProgress: 'Mediation progress',
    disputeOccurred: 'Place of dispute',
    applicant: 'Applicant',
    applicantsAgent: "Applicant's agent",
    respondent: 'Respondent',
    respondentsAgent: "Respondent's agent",
    viewDetails: 'View details',
    mediationOrganization: 'Mediation organization',
    chooseMediator: 'Select a mediator',
    enterMediatorsName: "Please enter the mediator's name",
    enterMediators: 'Please enter the mediator',
    choose: 'Choose',
    progressDetails: 'Progress details',
    currentStatus: 'Current status: ',
    importantTips: 'Important tips',
    acceptTheCase:
      'Please decide whether or not to accept the case according to the fact, and if you choose "Not accept", the applicant will not be able to enjoy the mediation service provided by this organization',
    notAcceptTheCase:
      'Please decide whether or not to accept the case according to the fact, and if you choose "Accept", the applicant will enjoy the mediation service provided by this organization',
    notAcceptCase: "Didn't accept the case",
    reason: 'Reason',
    detailedReasons: 'Detailed reason',
    transferOrganization: 'Transfer organization',
    enterReasonsTransfer:
      'Please fill in the reason for the transfer first(required)',
    selectType: 'Please select a type',
    enterOrganization: 'Please enter the organization name',
    transfer: 'Transfer',
    notUnderOrganization: "Not under this organization's jurisdiction ",
    otherOrganizationsAccepted: 'Other organization has accepted/resolved',
    mediationIsntGranted:
      "Mediation is not granted according to the case's nature",
    otherReasons: 'Other reasons',
    all: 'All',
    waitingMediation: 'Waiting for mediation',
    isMediating: 'Is mediating',
    allTime: 'All time',
    withinAWeek: 'Within a week',
    withinAMonth: 'Within a month',
    withinAYear: 'Within a year',
    customTime: 'Custom Time',
    mediationTypes: 'All mediation types',
    peopleMediation: "People's mediation",
    administrativeMediation: 'Administrative mediation',
    asssignMediatorSuccessfully: 'Allocate the mediators successfully',
    transferMediationOrganizationSuccessfully:
      'Transferring mediation organization succeed',
    rejectSuccessfully: 'Not accepted successfully',
    acceptSuccessfully: 'Accept successfully',
    allTypes: 'All types'
  },
  addservice: {
    addServiceStaff: 'Add a service staff',
    basicInformation: 'Basic information',
    politicalStatus: 'Political status',
    IDNumber: 'ID number',
    uploadIDCard: 'Upload ID card',
    front: 'Front',
    reverseSide: 'Reverse side',
    contactPhone: 'Contact phone',
    contactEmail: 'Contact email',
    degreeOfEducation: 'Degree of education',
    occupationInformation: 'Occupation information',
    areasOfExpertise: 'Areas of expertise',
    separateWithCommas:
      'Please separate with commas, such as: marital disputes, distribution of property',
    qualificationCertificate: 'Qualification certificate',
    uploadTheCertificate: 'Upload the certificate',
    occupation: 'Occupation',
    workingOrganization: 'Working organization',
    workAddress: 'Work address',
    detailAddress: 'Detail address',
    timeToStartWorking: 'Time to start working',
    careerExperience: 'Career experience',
    platformFunction: 'Platform function',
    typeOfFunction: 'Type of function',
    serviceOrganization: 'Service organization',
    serviceArea: 'Service area',
    add: 'Add',
    save: 'Save',
    queryServiceStaff: 'Query service staff',
    enterServiceStaffsTelephone:
      "Please enter the service staff's  telephone number",
    enterCorrectPhone: 'Please enter the correct phone number',
    sure: 'Sure',
    phoneNumberFormatError: 'Phone number format error',
    wrongIDNumberFormat: 'Wrong ID number format',
    separateAreasOfExpertise: 'Please separate areas of expertise in commas',
    enterName: 'Please enter the name',
    enterPhoneNumber: 'Please enter the telephone number',
    selectFunctionType: 'Please select a function type',
    selectServiceOrganization: 'Please select a service organization',
    selectServiceArea: 'Please select a service area',
    CommunistPartyofChina: 'Member of Communist Party of China',
    ProbationaryPartyMembers: 'Probationary party members',
    communistYouthLeague: 'the Communist Youth League',
    MDC:
      'Member of the MDC(The Revolutionary Committee Of The Chinese Kuomintang)',
    CDL: 'Member of the CDL(China Democratic League)',
    CDNCA:
      'Member of the CDNCA(China Democratic National Construction Association)',
    DPP: 'Member of the DPP(Democratic Progressive Party)',
    CPWDP:
      "Member of the CPWDP(Chinese Peasants' and Workers' Democratic Party)",
    thePublicParty: 'To members of the public party',
    JiusanSocietyMembers: 'the Jiusan Society Members',
    TDSL: 'Member of the TDSL(Taiwan Democratic Self-Government League)',
    nonpartyPersonage: 'Nonparty personage',
    ordinaryResident: 'Ordinary resident',
    modifyingServiceStuffSucceed: 'Modifying service stuff succeed',
    addingServiceStaffSucceed: 'Adding service staff succeed',
    nationality: 'Please select your nationality'
  },
  capabilitydetail: {
    assessmentDetails: 'Assessment details',
    name: 'Name',
    organization: 'Organization',
    assessmentCycle: 'Assessment cycle',
    assessmentResult: 'Assessment result',
    totalScore: 'Total score',
    grade: 'Grade',
    processingRate: 'Processing rate',
    weight: 'Weight',
    caseprocessingRate: 'Case processing rate during the assessment cycle',
    numberOfCasesMediated: 'Number of cases mediated',
    casesBeingMediated: 'Number of cases being mediated',
    score: 'Score',
    successRate: 'Success rate',
    successRateCasesProcessed:
      'Success rate of cases processed during assessment cycle',
    numberOfSuccessfulMediation: 'Number of successful mediation',
    numberOfAssessments: 'Number of assessments',
    satisfaction: 'Satisfaction'
  },
  capabilityevaluate: {
    competencyAssessmentAnalysis: 'Competency assessment analysis',
    export: 'Export',
    organization: 'Organization',
    assessmentCycle: 'Assessment cycle',
    affiliatedOrganization: 'Affiliated organization',
    assessmentScore: 'Assessment score',
    assessmentRating: 'Assessment rating',
    operate: 'Operate',
    view: 'View',
    number: 'Number',
    allOrganizations: 'All organizations',
    allStaff: 'All staff',
    organizationalCapacityAssessment: 'Organizational capacity assessment',
    capacityAssessment: 'Capacity assessment of mediators'
  },
  comfirmlist: {
    organizationsManagementCenter: "Organization's management center",
    judicialConfirmationList: 'Judicial confirmation list',
    enterPersonnelName: 'Please enter the personnel name',
    search: 'Search',
    mediationType: 'Type of mediation',
    expand: 'Expand',
    hide: 'Hide',
    registrationTime: 'Registration time',
    sure: 'Sure',
    disputeNo: 'Dispute number',
    caseStatus: 'Case status',
    pendingConfirmation: 'Pending confirmation',
    allocationOfJudges: 'Allocation of judges',
    confirm: 'Confirm',
    caseDetails: 'Case details',
    caseProgress: 'Case progress',
    judicialConfirmationCaseNo: 'Judicial confirmation case number'
  },
  dossierdetail: {
    organizationManagement: 'Organization management',
    fileRecords: 'File records',
    fileDetails: 'File details',
    fileProgress: 'File progress',
    progress: 'Progress',
    status: 'Status',
    disputeNo: 'Dispute number',
    fileCatalogue: 'File catalogue',
    fileCover: 'File cover',
    volumeName: 'Volume name',
    caseNo: 'Case number',
    agreementNo: 'Agreement number',
    mediator: 'Mediator',
    mediationDate: 'Date of mediation',
    filingDate: 'Filing date',
    remark: 'Remark',
    filingPeople: 'Filing people',
    auditor: 'Auditor',
    passAudit: 'Pass the audit',
    backToTheFile: 'Back to the file',
    currentStatus: 'Current status',
    confirmFileInformation:
      'Confirm that the file information is correct? Pass the audit?',
    reasonsForReturn: 'Reasons for return',
    enterReasonForReturn: 'Please enter the reason for return',
    fileReviewPassed: 'File review passed',
    reviewPassed: 'Review passed',
    fileReturnedSuccessfully: 'File returned successfully',
    catalogueInVolume: 'Catalogue in volume',
    backCover: 'Back cover',
    revokeFile: 'Revoke the file',
    fileReviewFailed: 'File review failed',
    newFile: 'New file',
    fileReviewModified: 'File review modified',
    fileHasBeenSubmitted: 'The file has been submitted for review',
    fileReviewSucceed: 'File review succeed'
  },
  dossierlist: {
    organizationsManagementCenter: "Organization's management center",
    fileRecords: 'File records',
    no: 'No',
    filingPeople: 'Filing people',
    type: 'Type',
    time: 'Time',
    startDate: 'Start date',
    endingDate: 'Ending date',
    fileNo: 'File number',
    applicant: 'Applicant',
    filingTime: 'Filing time',
    viewDetails: 'View details',
    currentOrganization: 'Current organization',
    backfillFilterCriteria: 'Backfill the filter criteria for the current list',
    saveFilterCriteria: 'Save the filter criteria for the current list'
  },
  mediatelist: {
    caseMediationRecords: 'Case mediation records',
    disputeMediation: 'Dispute mediation',
    migrated: 'Migrated',
    selectRegion: 'Select region',
    enterNameNumberCase: 'Please enter your name/number/case number',
    search: 'Search',
    disputeType: 'Dispute type',
    selectDistrictTown: 'Please select the district/town',
    selectStreet: 'Please select a street',
    selectProvince: 'Please select the province',
    selectCity: 'Please select the city',
    listOfProvinces: 'List of provinces',
    provinces: 'Provinces',
    city: 'City',
    backfillFilterCriteria: 'Backfill the filter criteria for the current list',
    customTime: 'Custom Time',
    saveFilterCriteria: 'Save the filter criteria for the current list'
  },
  organlist: {
    organizationsAdministrator: "Organization's administrator",
    serviceOrganizationList: 'Service organizations list',
    serviceOrganization: 'Service organization',
    mediationMethods: 'Mediation methods',
    mediator: 'Mediator',
    organizationDetails: 'Organization details',
    details: 'Details',
    phone: 'Phone',
    personInCharge: 'Person in charge',
    personInCharge2: 'Person in charge: ',
    address: 'Address',
    address2: 'Address: ',
    contactPhoneNumber: 'Contact phone number',
    positionOfPerson: 'Position of person in charge',
    contactEmail: 'Contact email',
    organizationIntroduction: 'Organization introduction',
    organizationsName: "Organization's name",
    organizationsName2: "Organization's name: ",
    organizationsLandlineNumber: "The organization's landline number",
    administrativeLevel: 'Administrative level',
    groupAddress: "Organization's address",
    superiorOrganization: 'Superior organization',
    organizationCode: 'Organization code',
    pleaseEnterOrganizationCode: 'Please enter organization code',
    telephone: 'Telephone: '
  },
  servicelist: {
    nationality: 'Nationality',
    serviceStaffList: 'Service staff list',
    enterPersonnelName: 'Please enter the personnel name',
    search: 'Search',
    serviceArea: 'Service area',
    areasOfExpertise: 'Areas of expertise',
    expand: 'Expand',
    hide: 'Hide',
    details: 'Details',
    details2: 'Details: ',
    starLevel: 'Star level',
    numberOfAssessments: 'Number of assessments',
    practiceExperience: '{number} years of practice experience',
    type: 'Type',
    type2: 'Type: ',
    organization: 'Organization',
    organization2: 'Organization: ',
    personnelDetails: 'Personnel details',
    yearsOfPractice: 'Years of practice',
    yearsOfPractice2: 'Years of practice: ',
    typeOfFunction: 'Type of function',
    serviceOrganization: 'Service organization',
    pendingCompletion: 'Pending completion',
    completed: 'Completed',
    basicInformation: 'Basic information',
    gender: 'Gender: ',
    degreeOfEducation: 'Degree of education',
    dateOfBirth: 'Date of birth: ',
    politicalStatus: 'Political status',
    contactPhone: 'Contact phone',
    IDNumber: 'ID number',
    contactEmail: 'Contact email',
    typeOfOccupation: 'Type of occupation',
    qualificationCertificate: 'Qualification certificate',
    workingOrganization: 'Working organization',
    workAddress: 'Work address',
    careerExperience: 'Career experience'
  },
  adjust: {
    applicationMediation: 'Mediation application form',
    return: 'Return',
    basicInformation: 'Basic information',
    courtAcceptedApplication: 'The court accepting the application',
    caseType: 'Case type',
    partysBasicInformation: "The party's basic information",
    zipCode: 'Zip code',
    zipCode2: 'Zip code: ',
    deliveryMethod: 'Delivery method',
    deliveryMethod2: 'Delivery method: ',
    fillInstrumentDeliveryAddress:
      'Please be sure to fill in the Instrument delivery address',
    instrumentDeliveryAddress: 'Instrument delivery address',
    claimMatters: 'Request matter',
    requestContent: 'Request content',
    requestContent2: 'Request content: ',
    fillAppeals: 'Please fill in the appeals',
    evidenceMaterial: 'Evidence material',
    materialCategories: 'Material categories',
    materialCategories2: 'Material categories: ',
    pleaseSelect: 'Please select',
    materialName: 'Name of material',
    materialAttachments: 'Material attachments',
    materialAttachments2: 'Material attachments: ',
    clickToUploadFile: 'Click to upload file',
    newMaterial: 'New material',
    newMaterials: 'For a variety of materials, please click on "New Materials"',
    queryPassword: 'Query password',
    enterTheQueryPassword: 'Please enter the query password',
    submitAnApplication: 'Submit an application',
    judicialConfirmationSubmissionSucceed:
      'Judicial confirmation submission succeed',
    applicationJudicialConfirmation: 'Application for judicial confirmation',
    certificateOfJudicialConfirmation: 'Certificate of judicial confirmation',
    mediationAgreement: 'Mediation agreement',
    partysCertification: "The party's certification",
    civil: 'Civil',
    organ: 'Organ',
    publicInstitution: 'Public institution',
    peoplesOrganization: "People's organization",
    stateOwnedEnterprise: 'State-owned enterprise',
    affiliatedEnterprise: 'State-owned affiliated enterprise',
    collectivelyOwnedEnterprise: 'Collectively-owned enterprise',
    collectiveAffiliatedEnterprise:
      'State-owned and collective affiliated enterprise',
    privateEnterprise: 'Private enterprise',
    privatePartnershipEnterprise: 'Private partnership enterprise',
    privateLiabilityLimitedCompany: 'Private liability limited company',
    individualBusiness: 'Individual business',
    individualPartnership: 'Individual partnership',
    SCollectiveAffiliatedEnterprise:
      'State-owned and collective affiliated enterprise',
    SOPrivateAffiliatedEnterprise:
      'State-owned and private affiliated enterprise',
    CPrivateAffiliatedEnterprise:
      'Collective and private affiliated enterprise',
    collectiveAndPrivateEnterprise:
      'State-owned, collective and private enterprise',
    limitedLiabilityCompany: 'Limited liability company',
    limitedLiabilityCompany2: 'Limited liability company',
    ChineseForeignJointVenture: 'Chinese-foreign joint venture',
    ChineseForeignCoOperativeEnterprise:
      'Chinese-foreign co-operative enterprise',
    foreignFundedEnterprise: 'Foreign-funded enterprise',
    jointVentureEnterprise: 'Joint venture enterprise with mainland China',
    jointOperationEnterprise: 'Joint operation enterprise with mainland China',
    whollyOwnedEnterprises:
      'Hong Kong, Macao and Taiwan wholly-owned enterprises',
    army: 'Army',
    otherEconomic: 'Other economic'
  },
  applyRecord: {
    applicationFiling: 'Application for filing',
    operateAgain:
      'The form information is not entered correctly, please reoperate!!',
    evidenceCompletedOrBlank:
      'Each piece of evidence must be completed or blank',
    applicationForFilingSucceed: 'Application for filing succeed'
  },
  judicialDetail: {
    filingProgressInquiry: 'Filing progress inquiry',
    caseInfo: 'Case information',
    serialNumber: 'Serial number',
    caseNo: 'Case number',
    courtOfAcceptance: 'The court of acceptance',
    caseType: 'Case type',
    causeAction: 'Cause of action',
    deliveryMethod: 'Delivery method',
    enforcementBasis: 'Enforcement basis',
    filingTime: 'Filing time',
    sourceCase: 'Source of the case',
    litigationAmount: 'Litigation amount',
    identityOfTheFiling: 'The identity of the filing',
    litigationClaims: 'Litigation claims',
    partysInformation: "The party's information",
    partyType: 'The party type',
    litigationStatus: 'Litigation status',
    agentLitem: 'Agent ad litem',
    agentsSerialNumber: "The agent's serial number",
    nationality: 'Nationality',
    typeOfDocument: 'Type of document',
    typeOfDocument2: 'Type of document：',
    pleaseSelectDocument: 'Please select type of document',
    zipCode: 'Zip code',
    nationality2: 'Nationality',
    politicalStatus: 'Political status',
    degreeOfEducation: 'Degree of education',
    legalRepresentative: 'Legal representative',
    legalRepresentativesTypeOfDocuments:
      "Legal representative's type of documents",
    legalRepresentativesIDNumber: "Legal representative's ID number",
    agentsInformation: "Agent's information",
    typeDefense: 'Type of defense',
    agentsName: "Agent's name",
    agentsPhoneNumber: "Agent's telephone",
    agentZIPCode: 'Agent ZIP code',
    agentsAddress: "Agent's address",
    agentsPractisingCertificateNumber: "Agent's practising certificate number",
    typesOfAgentDocuments: 'Types of agent documents',
    agentIDNumber: 'Agent ID number',
    agentsOrganization: "Agent's organization",
    serialNumber2: 'Serial number of the party corresponding to the agent',
    reviewInformation: 'Review information',
    caseStatus: 'Case status',
    reviewer: 'Reviewer',
    dateOfReview: 'Date of review',
    reviewOpinions: 'Review opinions',
    reasonsForReviewOpinions: 'Reasons for review opinions',
    age: 'Age',
    partyNumber: 'Party number'
  },
  //   lawsuit
  applylawsuit: {
    applicationForLitigation: 'Application for litigation',
    enterKeywords: 'Enter keywords to search',
    amountOfSubject: 'Amount of subject',
    enterAmountOfSubject: 'Please enter amount of subject',
    requestContent: 'Request content',
    fillAppeals: 'Please fill in the appeals',
    appealMaterials: 'Appeal materials',
    materialCategories: 'Material categories',
    materialName: 'Name of material',
    materialAttachments: 'Material attachments',
    clickToUploadFile: 'Click to upload file',
    newMaterial: 'New material',
    newMaterials: 'For a variety of materials, please click on "New Materials"',
    submitAnApplication: 'Submit an application',
    selectCourt: 'Select a court',
    successfulSubmission: 'Successful submission of litigation application',
    reselect:
      'There are no cases under the current court and case type, please reselect',
    proceedingDetails: 'Proceeding details'
  },
  disputeType: {
    all: 'All',
    NPL: 'Network product liability disputes',
    NC:
      'Disputes over the ownership of network copyright and neighboring rights',
    OS: 'Online shopping contract disputes',
    NDN: 'Network domain name ownership, infringement and contract disputes',
    NI:
      "Network infringement of other people's personal rights, property rights and other civil interests disputes",
    NPI: 'Network public interest litigation',
    NSC: 'Network service contract disputes',
    AD: 'Administrative disputes caused by network administrati',
    NFL:
      'Network financial loan contract disputes, small loan contract disputes',
    NR:
      'Disputes over infringement of network copyright and neighboring rights',
    other: 'Other disputes',
    DOPR: 'Disputes of personality rights',
    DOMFAS: 'Disputes over Marriage,Family and Succession',
    DPR: 'Disputes over Property Rights',
    DCIPANG: 'Disputes over Contracts,Improper profit and Negotiorum gestio',
    DIPAC: 'Disputes over Intellectual Property and Competition',
    DLAP: 'Disputes over Labor and Personnel',
    DMAM: 'Disputes over Marine and Maritime',
    CDOCSIA:
      'Civil disputes over Companies, Securities, Insurance and/or Negotiable Instruments. Etc',
    DOTL: 'Disputes over Tort Liability',
    CAFCSTSP: 'Causes of Action for Cases Subject to Special Procedures'
  },
  room: {
    invite: 'Invite',
    happy: 'Happy: ',
    angry: 'Angry: ',
    sad: 'Sad: ',
    calm: 'Calm: ',
    afraid: 'Afraid: ',
    annoyed: 'Annoyed: ',
    surprised: 'Surprised: ',
    disputeMaterials: 'Dispute materials',
    voice: 'Voice',
    video: 'Video',
    privateChat: 'Private chat',
    EmotionsOfCalm:
      'The system will recognize 7 emotions of calm, <br>pleasure, anger, fear, sadness, disgust and surprise through<br> facial expressions, and will issue an alert <br>if the person is too angry or sad during the mediation process <br>to help you better mediate the dispute',
    detectVideoAndAudio: 'Detect video and audio',
    playDiscipline: 'Play discipline',
    endVideo: 'End video',
    stopRecording: 'Stop recording',
    startRecording: 'Start recording',
    startRecording2: 'Start recording2',
    startRecording3: 'The current video is being recorded',
    startRecording4: 'Recording',
    stopRecording2: 'The current video has stopped recording',
    leave: 'Leave the video',
    quitVideoConference: 'Quit the video conference',
    shareFaceExpressionRecognition: 'Share of face expression recognition(%)',
    communicationRecords: 'Communication records',
    videoTurnedOff: 'Video is turned off',
    observer: 'Observer ',
    browserNotSupportVideo:
      "The current browser doesn't support video conference, please use Chrome (version above 52) or QQ browser (10.2)",
    connectionIsInterrupted: 'Meeting connection is interrupted',
    videoConnectionFailed: 'Video connection failed, please try again',
    retry: 'Retry',
    whetherToEnd: 'Whether to end the current video conference?',
    whetherToRcording: 'Whether to start recording video?',
    whetherToStopRecording: 'Whether to stop recording video?',
    cantBeSccessedAgain:
      "After the video is finished, this video mediation will end and the video can't be accessed again",
    leaveTemporarily: 'Leave temporarily',
    endRecording: 'End recording',
    enterWithinOneHour:
      'Please enter the video within 1 hour, otherwise the system will end this video mediation by default ...',
    leaveVideo: 'Leave the video and the video page will close',
    comfirmAndLeave: 'Video conference is over, please comfirm and leave',
    videoClosedByMediatorTip_1:
      'The mediator temporarily blocks your audio and video',
    videoClosedByMediatorTip_2: ' Please wait for recovery',
    videoForbidden: 'Blocked',
    videoRecovery: 'Recovery',
    voiceTotext:
      'The mediator opened the voice-to-text function, the voice will automatically convert to text to generate the mediation record',
    voiceTotextOff: 'The mediator closed the voice-to-text function'
  },
  level: {
    low: 'Low',
    middle: 'Middle',
    high: 'High'
  },
  header: {
    hello: 'Hello,',
    online: 'Online',
    busy: 'Busy',
    exit: 'Exit',
    home: 'Home',
    LegalAdvice: 'Legal advice',
    more: 'More',
    lawsAndRegulations: 'Laws and Regulations',
    caseLibrary: 'Case Library',
    regulatoryCase: 'Regulatory and Case',
    serviceResources: 'Service Resources',
    helpCenter: 'Help Center',
    mediationCentre: 'Mediation Centre',
    FAQ: 'FAQ',
    welcomeToRegister: 'Welcome to register',
    alreadyHave: 'Already have an account?',
    pleaseLogin: 'Please login',
    welcomeToLogin: 'Welcome to login',
    staffLogin: 'The staff login',
    retrievePassword: 'Retrieve password',
    backLogin: 'Back to login',
    backToHome: 'Back to home page',
    help: 'Help',
    resourceDatabase: 'Mediation Resource Database'
  },
  inside: {
    communicationRecords: 'Communication records',
    InSpeechRecognition: 'In automatic speech recognition',
    turnOnSpeechRecognition: 'Turn on',
    manual: 'Manual input',
    speechRecognition: 'Automatic speech recognition ',
    pressENTERToSend: 'Enter the message here and press ENTER to send',
    mediationGuideline: 'Mediation guideline',
    mediationGuidelineCase: 'Mediation guideline for {type} type case ',
    videoCertification: 'Video certification',
    authenticateTheParties: 'Do you agree to authenticate the parties?',
    materialUpload: 'Material upload',
    tip:
      'Tip: The current dispute is "{type}", the recommended evidence is {evidence}, files uploaded shouldn‘t exceed 20M'
  },
  privatechat: {
    noChatInformation: 'There is no chat information currently',
    inConversation: 'In conversation with {somebody}',
    privateChatWindow: 'Private chat window'
  },
  other: {
    year: 'years',
    language: 'Language',
    day: 'Days',
    protocol:
      '"Guangzhou Court Online Dispute Resolution Platform Concerning Hong Kong And Macao Service Agreement"'
  },
  leftMenu: {
    securitySettings: 'Security settings',
    myProfile: 'My profile'
  },
  footer: {
    userCenter: 'User Center',
    howToMediate: 'How to mediate',
    howToViewResults: 'How to view results',
    mediationCentre: 'Mediation Centre',
    platformService: 'Platform service',
    litigationService: 'Litigation service',
    contactMethod: 'Contact method',
    customerServiceTel: 'Customer service Tel: ',
    customerServiceEmail: 'Customer service Email: ',
    smallProgram: 'Small program'
  },
  realName: {
    realNameCertification: 'Real name authentication',
    name: 'name: ',
    IdNumber: 'ID Number: '
  },
  home: {
    personalCenter: 'Enter personal center',
    exit: 'Exit',
    login: 'Login',
    enterPhoneOrEmail: 'Please enter phone number or email address',
    register: 'Register now',
    contactAdministrator: 'Contact the administrator for additional questions',
    passwordLogin: 'Password login',
    captchaLogin: 'Captcha login',
    passwordAndCaptchaLogin: 'Password and Captcha login',
    ukeyLogin: 'Ukey login',
    phoneNumberCantBeBlank: "The phone number can't be blank",
    emailFormatError: 'Email format error',
    staff: 'Staff',
    onlineDisputeResolution: 'Online dispute resolution',
    onlineDisputeResolution2:
      'Online entry of disputes, online response of authoritative resources, professional support for diversified resources, rapid resolution of disputes',
    qualityTeam: 'Quality team  Resolve disputes',
    qualityTeam2: 'Match the institutional mediators efficiently by type',
    saveTime: 'Save time and labour  Safeguard rights and interests',
    saveTime2: 'Remain within doors One-click to solve the dispute',
    wholeProgress: 'Track the whole progress of the case ',
    SMSNotification:
      'SMS notification through the whole process of case circulation',
    organizer: 'Organizer: ',
    ChineseDomain: 'Chinese domain name: ',
    filingNumber: 'Filing number: ',
    courtAddress: 'Court address: ',
    courtTel: 'Court Tel: ',
    technicalServiceHotline: 'Technical Service Hotline: ',
    welcome: 'Welcome',
    welcomeTo:
      'Welcome to Online dispute resolution platform for foreign-related civil and commercial cases of Hainan',
    professional:
      'Professional consultants, institutional mediators, diversified resources',
    guidingCase: 'Guiding case',
    hello: 'Hello,',
    please: 'Please',
    mediation: 'Dispute mediation:',
    case: 'case',
    title1: 'Hong Kong, Macao and Taiwan cases',
    content1:
      'The cases of Hong Kong, Macao and Taiwan refer to the case whose parties are citizens or organizations of Hong Kong, Macao or Taiwan, the object of litigation or the legal relationship of the lawsuit taking place in Hong Kong, Macao or Taiwan, including civil and commercial cases, criminal cases, administrative cases and so on.',
    title2: 'Guiding cases of the Supreme Court of PRC',
    content2:
      "The guiding cases of the Supreme Court refer to the cases which are compiled under the procedure of the Provisions of the Supreme People's Court on the guiding work of the case, discussed and uniformly published by the judicial committee of the Supreme People's Court, and represent the will of the Supreme People's Court. People's courts at all levels should refer to these guiding cases when judging similar cases. These cases are widely concerned by the society, concerning legal principles, having typical significance, involving the complex or new type issues or having other guiding functions.",
    title3: 'Foreign-related (including the Belt and Road) cases',
    content3:
      'Foreign-related cases refer to cases contain foreign-related factors, including the civil and commercial cases having the foreign-related subject, object or legal relationship, the criminal cases having foreign-related subject, litigation process or place where the act or the result occurred, and the administrative cases initiated by the foreign plaintiff or third party against the Chinese administrative organs. The guiding cases concerning the construction of "Belt and Road" refer to cases issued by the Supreme People\'s Court on the basis of combing and summarizing the experience of foreign maritime and business trials in recent years, with the aim of harmonizing the application of laws in foreign commercial and maritime trials and realizing the equal judgment of similar cases.',
    learnMore: 'Learn More',
    HainanFreeTradeZone: 'Hainan Free Trade Zone'
  },
  service: {
    workingExperience: 'Working experience',
    noEvaluation: 'No evaluation',
    searchOrganization: 'Search Organization',
    searchStaff: 'Search Staff',
    searchLawyer: 'Search Public interest lawyer'
  },
  help: {
    stepsMediation: 'Steps to apply for mediation',
    courtLedMediation: 'Court-led mediation',
    allocationMediation: 'Allocation of mediation organizations to the case',
    platformNotifies: 'Platform notifies the parties',
    SMSNotifies: 'SMS notifies online mediation in time',
    mediatesOnline: 'Mediator mediates online',
    mediatorIntervene: 'The mediator intervene and mediate',
    successfulMediation: 'Successful mediation',
    mediatorConfirms: 'Mediator confirms the mediation status',
    judicialConfirmationOrMediation:
      'Application for judicial confirmation or mediation agreement',
    judicialConfirmation: 'Application for judicial confirmation',
    regAcc: 'Dispute registrars register dispute information',
    appMed: 'Mediating online intime by SMS or Email notification',
    medOnl:
      'Mediator intervenes, three parties participate in online video mediation',
    medSuc: 'Mediation succeeded, confirm the mediation agreement online',
    appJud:
      'Apply to court to confirm the validity of the mediation agreement online'
  },
  agreementRegister: {
    serviceAgreement:
      'Guangzhou court online dispute resolution platform concerning Hong Kong and Macao service agreement',
    versionEffectiveDate: 'Version Effective Date:',
    time: 'April 14, 2018 10:49',
    indent:
      '"Guangzhou court online dispute resolution platform concerning Hong Kong and Macao" (hereinafter referred to as "the platform") is an integrated service platform for online dispute resolution, aimed at providing online consultation, mediation, arbitration, evaluation, litigation and other services to the public. Before using the services of the platform, it is important that you carefully read and thoroughly understand this agreement, in particular the terms of exemption or limitation of liability, the application of laws and the terms of dispute resolution. The terms of exemption or limitation of liability will be marked in bold, and you should focus on while reading. You may choose not to use the platform service, but once you used, you are deemed to have approved all the contents of this service agreement.',
    indent2:
      'After you filling in the information, reading and agreeing to this agreement and completing all registration process which prompted by the registration page, you are deemed to have fully read, understood and accepted the contents of this agreement and have agreed with the platform to become a "user". During reading this agreement, if you do not agree to this agreement or any of its terms, you shall immediately discontinue the registration process.',
    title: 'I. Statement of intellectual property rights',
    content:
      'The platform has the intellectual property right of all the information content, the use technology, the design style and design program in the platform website, and any reproduction and dissemination of the information on this website for commercial purpose may constitute an infringement of the intellectual property rights of this website, the website will defend its rights in accordance with the law. No one could use it without permission of the platform. Otherwise, the platform will investigate legal responsibility according to law.',
    title2: 'Ⅱ.Provisions on the right of privacy',
    num1:
      "1. The platform respects and protects the personal privacy rights of all users who use the platform. Include data such as your account name, IP address, bank account, email address, contact details, browser type, access time, hardware and software feature information, and page records of your needs on the platform. The platform won't provide and share your personal information to third parties (except those that have partnerships with our platform).",
    num2:
      '2. The data about your transactions by using the platform, your credit evaluation, and the processing decisions taken by the platform against you as a result of your violation or breach of contracts are public information on this website and are not protected by the privacy right.',
    num3:
      '3. The platform does not allow any third party to collect, edit, sell or distribute your personal information by any means. If any user of the platform who engages in such activities, the victim need to inform the  platform in writing and provide relevant evidence in time, after the review and confirmation of this website, or the weibsite finds such infringement on its own, the website will have the right to terminate the service agreement with the infringing user immediately.',
    num4:
      '4. If a third party who is not a user of this platform uses your information on this website to infringe your rights and interests, as this website does not have the right to take measures against users who are not members of the website, please defend your rights in accordance with the law in time, this website will give the necessary cooperation.',
    num5:
      '5. In order to better serve you or protect the legitimate rights and interests of other users, the platform has the right to send you relevant information by using the personal information you provide, to take measures to protect your privacy and to conduct relevant investigations.',
    num6:
      '6. If you complain other infringers about your privacy and information to the platform, the platform has the right to disclose your information and proof of rights in relation to the complaint to the respondent in order to safeguard your rights and resolve the dispute.',
    num7:
      '7. If you are complained or violate national laws, regulations, the platform service agreements and other related rules, the platform has the right to disclose your information to interested parties, but the scope of disclosure is limited to the legitimate interests of the complainant.',
    num8:
      "8. When a platform consultant needs to communicate or trade with a conselor, as the party of the transaction, both the consultant and the conselor have the right to know the relevant information of the other party for the exchange or transaction needs. And the party who knows the other party's transaction information is obliged not to divulge the information to the third parties. If you infringe others' rights and divulge the information, the platform has the right to disclose your information to the injured party and the relevant state authorities in the event that the aggrieved party can prove the infringement.",
    num9:
      '9. In order to achieve your purpose of logging on this website, or for the purpose of communicating or trading with you, the platform has the right to use your information within reasonable limits.',
    num10:
      "10. Please properly protect your account and password, the platform will also take technical measures to prevent your information from being compromised. But due to current technical and practical constraints, there is no hundred percent and absolute safe technical measures, the platform won't assume legal responsibility for this without intentional behavior."
  },
  //   dtuMediation
  dossier: {
    listCases: 'List of my cases',
    casesMediated: 'Cases mediated',
    caseDetails: 'Case details',
    electronicFiles: 'Electronic files',
    disputeNo: 'Dispute number',
    identityStatus: 'Identity status: ',
    fileProgress: 'File progress',
    uploadMaterials: 'Upload materials',
    generateTheFile: 'Generate the file',
    catalogueInVolume: 'Catalogue in volume',
    fileCover: 'File cover',
    volumeName: 'Volume name',
    agreementNo: 'Agreement number',
    mediationDate: 'Date of mediation',
    filingPeople: 'Filing people: ',
    filingDate: 'Filing date: ',
    auditor: 'Auditor: ',
    withdrawFile: 'Withdraw the file',
    archiveFiles: 'Archive files',
    withdrawalFiles:
      'The withdrawal of files will clear the files and the documents in file area',
    reconfirmWhetherToSubmit:
      "Reconfirm whether to submit, once submitted, it can't be modified.",
    revokeFile: 'Revoke the file',
    auditFailed: 'File review failed',
    newFile: 'New file',
    fileModification: 'File modification',
    archived: 'Archived',
    auditSucceed: 'File review succeed',
    identityCertificate: 'Identity certificate',
    listOfEvidence: 'List of evidence',
    clericalMaterials: 'Clerical materials',
    letterAuthorization: 'Letter of authorization',
    partysCertification: "The party's certification",
    agentsIdentification: "Agent's identification",
    defaultAttachments: 'Default attachments',
    applicationMediation: 'Mediation application form',
    notice: "Notice of the party's rights and obligations",
    mediationTranscript: 'Mediation transcript',
    investigationTranscript: 'Investigation transcript',
    mediationAgreement: 'Mediation agreement',
    performanceProof: 'Performance proof of the mediation agreement',
    applicationJudicialConfirmation: 'Application for judicial confirmation',
    mediationReturnRecords: 'Mediation return records',
    closingTable: 'Closing table',
    evidenceMaterial: 'Evidence material of mediation',
    selectCategory: 'Please select a type',
    selectMaterial: 'Please select the material name',
    uploadFileFirst: 'Please upload the file first',
    withdrawalSucceed: 'Withdrawal succeed',
    sentSuccessfully: 'Sent successfully',
    notes: 'Notes',
    promptMessage: 'Prompt Message'
  },
  question: {
    platformGuide: 'Platform guide',
    userLogin: 'User Login',
    platformService: 'Platform service',
    mediationServiceForDisputes: 'Mediation service for disputes',
    serviceResources: 'Service resources',
    usageProcess: 'Usage process',
    applicationForMediation: 'Application for mediation',
    viewResults: 'View results',
    accountSettings: 'Account settings',
    realNameAuthentication: 'Real name authentication',
    modifyPassword: 'Modify password',
    personalInformation: 'Personal information',
    handwrittenSignature: 'Handwritten signature',
    register1:
      'New users can click the "Register" button in the upper-right corner of the platform\'s home page to enter the registration page.',
    register2:
      'New user inputs mobile phone number → Clicks "Get verification Code" → Enters the verification code → Sets password, after filling completely, the user can view by clicking "Guangzhou Court Online Dispute Resolution Platform Concerning Hong Kong And Macao Service Agreement", and click the option of I agree to the "Guangzhou Court Online Dispute Resolution Platform Concerning Hong Kong And Macao Service Agreement" after checking. It represent that the user has read and agreed to the terms of service.',
    register3:
      'Click on the "Register" button, the pop-up window will prompt the user that the registration succeeded. The user can choose whether to go to the personal center to complete personal information.',
    login1:
      'Users can click on the "Login" button in the upper right corner of the platform home page, enter the login page, then enter the phone number and password, click the "Login" button to successfully log on to the platform. After it, you can enjoy online consultation, online mediation, online litigation and other services.',
    forgetPwd: 'Forgot password',
    login2:
      'Users can click on the "Login" button in the upper right corner of the platform home page, enter the login page, if you forget the password, you can click "Forgot Password?" button, fill the required information "Mobile phone number", "Mobile verification code", "New password", "Duplicate password", then click the "Confirm" button, the system will prompt the password modification succeeded. Users can log on to the platform using their account number and new password.',
    userRegistrationAgreement: 'User registration agreement',
    agreement:
      '"Guangzhou Court Online Dispute Resolution Platform Concerning Hong Kong And Macao Service Agreement" is an agreement between the platform and the user, users need to read the agreement when register and confirm the relevant information. The content of the agreement include the platform\'s intellectual property statement, privacy provisions, registration and use rules, platform usage rules, provisions of fees, dispute resolution methods, liability for breach of contract, modification and termination of agreements and so on, and the platform has marked the terms of exemption or limitation of liability in bold to prompt the user to focus while they reading.',
    introductionToDisputeMediationService:
      'Introduction to dispute mediation service',
    mediation:
      'Mediation refers to the activities of a third party other than the parties, based on national laws, regulations and policies and social ethics, channeling and persuading the parties to consult and promote mutual understanding between them, finally reaching an agreement voluntarily and resolving the dispute.',
    applicant:
      'The applicant can apply for mediating a case on the platform and choose his or her intended mediation organization, which will assign an appropriate mediator for the case, and the mediator will contact the parties to deal with the dispute.',
    types: 'What are the types of dispute mediation services',
    platform:
      "The platform divides dispute mediation into people's mediation and administrative mediation.",
    mediator: 'What is the "mediator"?',
    serviceStaff:
      'The mediators are the service staff who are responsible for mediating disputes among the people in the mediation organization on the platform. The main work content is promoting the parties to reach a mediation agreement voluntarily on the basis of equal communication through persuasion, guidance and so on, finally resolve contradictions and eliminate disputes.',
    administrator:
      'What is the administrator primarily responsible for on the platform',
    platformMediationOrganization:
      "The administrator of the platform mediation organization is primarily responsible for deciding whether to accept the user's case, assigning the mediators and reviewing the final file during the mediation process.",
    responsible:
      'What is the mediator primarily responsible for on the platform',
    mainlyResponsible:
      'The mediator of the platform mediation organization is mainly responsible for contacting the parties of the case to understand the situation of the dispute, organizing online video conference or offline meeting to resolve the dispute, and finally writing the corresponding instrument according to the result of the mediation, filing the file after setting up the mediation status on the platform.',
    difference:
      'The difference between a lawyer mediator and a general mediator',
    lawyerMediator:
      'The lawyer mediator is also a lawyer, compared with the general mediator, the lawyer mediator has the professional legal knowledge and the skillful vocational skills. And the ability to clear the contradictory dispute focus of the parties quickly and the unofficial identity make it easier to let the parties generate trust and have stronger affinity, which makes the mediation more efficient.',
    serviceResources2: 'What service resources are available on the platform',
    resourcesOfIndustries:
      'The platform brings together the resources of various industries, including people\'s mediation and administrative mediation, and constructs a set of organically connected "socialized mediation system". The platform also brings together the senior personnel from various organizations to build a stronger and more professional expert consultation library to provide higher quality consulting service for the public.',
    howToMediate: 'How to mediate',
    userApplies:
      'The dispute registrar will register the dispute to Hainan online dispute resolution platform for foreign-related civil and commercial disputes to entrust mediation organizations to mediate according to the details of the case. After the case enters mediation, the mediator will send a message to parties. Please pay attention to SMS notification, and timely login to the Hainan online dispute resolution platform for foreign-related civil and commercial disputes to participate in mediation.',
    viewMediationResults: 'How to view mediation results',
    logingOnThePlatform:
      'After the user loging on the platform, they can view all the mediation cases related to them in the mediation list, which shows the progress of the mediation. Users can click the "Dispute Details" button to view the case details and related material instruments. Users can also screen cases based on the progress of mediation. (Service-mediation)',
    completeRealNameAuthentication: 'How to complete real name authentication',
    afterUserLogs:
      'After the user log on to the platform, they can fill in the name and ID number for real name authentication in the account center-security setting-identity authentication. For users without a second-generation ID card, they can be verified by video certification with the mediator during mediation.',
    whyNeedRealNameAuthentication: 'Why need real name authentication',
    improveAccountSecurity:
      'Real name authentication can improve the account security level and trust level, when applying for mediation, the system will also automatically import real name authentication information to avoid repeated input.',
    modifyThePassword: 'How to modify the password',
    clickModify:
      'The user can click the "Modify" button in the Security settings-login password after loging on, and enter the original password, the new password, click the "Confirm" button to modify the password.',
    completePersonalInformation: 'How to complete personal information',
    personalDataSection:
      'After the user logs on to the platform, the personal information can be completed in the security settings and personal data section under the Account Center..',
    useOfEmail: "What's the use of email address?",
    identifyPersonalInformation:
      'Email as one of the ways to identify personal information, binding email can improve the security of users using the platform and facilitate the notification of various information.',
    twoAddresses:
      'What is the relationship between the two addresses?(Permanent Residence Address and Current Address)',
    permanentResidenceAddress:
      "The permanent residence address is the address of the household registration, the current address is the user's actual resident address, these two addresses can be consistent or inconsistent. The current address will be directly extracted by the system as the place where the dispute occurred during consultation, evaluation and mediation.",
    availableOnThePlatform:
      'What signature methods are available on the platform',
    instrumentMaterials:
      'For instrument materials that require the parties to sign (e.g. mediation transcripts, mediation agreements, applications for judicial confirmation, etc.), the platform provides the handwritten signature method.',
    handwrittenSignature2: 'How to make a handwritten signature?',
    elevantMaterialInstruments:
      'After the mediator sends the relevant material instruments, the user clicks the corresponding instruments in the "Workbench" (dispute details or video conference interface). If there is no objection, the user can click the "Agree" button, the system will automatically pops up a QR code, the user can use WeChat scan QR code for handwritten signature, clicking "Confirm" indicates  the document material has been signed successfully.',
    userRegistration: 'User registration'
  }
}



// WEBPACK FOOTER //
// ./src/publicResource/utils/lang/en.js